var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgScrumboardPana = function SvgScrumboardPana(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 100 750 260",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.42,419.33v25.35h4v2.76h-4v17h-74.3V449h5.5V445.6h-5.5v-5h-2.45v-2.3h2.91V419.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "386.85 419.4 386.85 464.12 367.12 464.12 367.12 448.68 372.62 448.68 372.62 445.6 367.12 445.71 367.12 440.66 364.63 440.66 364.67 438.06 367.58 437.98 367.58 419.33 386.85 419.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.45,447.07c0,.16,13.44.28,30,.28s30-.12,30-.28-13.44-.28-30-.28S385.45,446.92,385.45,447.07Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.45,444.5c0,.15,13.44.28,30,.28s30-.13,30-.28-13.44-.28-30-.28S385.45,444.34,385.45,444.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.59,437.56c0,.16,13.44.29,30,.29s30-.13,30-.29-13.45-.28-30-.28S381.59,437.41,381.59,437.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.22,456.45c0,.16,13.44.28,30,.28s30-.12,30-.28-13.45-.28-30-.28S381.22,456.3,381.22,456.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.48,402.85l-1.63,30a2,2,0,0,1-2,1.92l-54.08.39a2,2,0,0,1-2-2l-.17-23.39a2,2,0,0,1,2-2.05l33.25,0a2,2,0,0,0,1.44-.59L329,401.4a2,2,0,0,1,1.42-.59l14-.1A2,2,0,0,1,346.48,402.85Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M346.48,402.85l-1.63,30a2,2,0,0,1-2,1.92l-54.08.39a2,2,0,0,1-2-2l-.17-23.39a2,2,0,0,1,2-2.05l33.25,0a2,2,0,0,0,1.44-.59L329,401.4a2,2,0,0,1,1.42-.59l14-.1A2,2,0,0,1,346.48,402.85Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 286.64,
    y: 404.01,
    width: 59.09,
    height: 35.31,
    transform: "translate(635.44 841) rotate(179.58)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.32,406.93l-4.25,36.85a1.31,1.31,0,0,1-1.28,1.16l-57.58.42a1.32,1.32,0,0,1-1.31-1.2l-3.17-36.79A1.31,1.31,0,0,1,284,406l65-.47A1.31,1.31,0,0,1,350.32,406.93Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.39,397.18l-1.63,30.05a2,2,0,0,1-2,1.92l-54.08.39a2,2,0,0,1-2-2l-.17-23.39a2,2,0,0,1,2-2.05l33.25,0a2,2,0,0,0,1.44-.59l5.73-5.73a2.06,2.06,0,0,1,1.42-.6l14-.1A2,2,0,0,1,362.39,397.18Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.55,
    y: 398.34,
    width: 59.09,
    height: 35.31,
    transform: "translate(667.22 829.55) rotate(179.58)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.22,401.26,362,438.11a1.3,1.3,0,0,1-1.28,1.16l-57.58.42a1.3,1.3,0,0,1-1.31-1.19l-3.17-36.8a1.31,1.31,0,0,1,1.29-1.42l65-.47A1.3,1.3,0,0,1,366.22,401.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.32,404.21l-1.63,30.06a2,2,0,0,1-2,1.91l-54.08.4a2,2,0,0,1-2-2l-.17-23.4a2,2,0,0,1,2-2l33.26,0a2,2,0,0,0,1.43-.59l5.74-5.74a2,2,0,0,1,1.42-.59l14-.1A2,2,0,0,1,380.32,404.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.48,
    y: 405.38,
    width: 59.09,
    height: 35.31,
    transform: "translate(703.13 843.49) rotate(179.58)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.15,408.3l-4.24,36.85a1.29,1.29,0,0,1-1.28,1.15l-57.58.42a1.29,1.29,0,0,1-1.31-1.19l-3.17-36.79a1.3,1.3,0,0,1,1.29-1.42l65-.48A1.31,1.31,0,0,1,384.15,408.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.56,413.31v51.12h73.75V413.31Zm24.07,9.19a3.77,3.77,0,0,1,3.78-3.77h18a3.78,3.78,0,0,1,0,7.55h-18A3.78,3.78,0,0,1,340.63,422.5Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.81,413.31v51.12h39.75V413.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.38,
    y: 109.82,
    width: 101.45,
    height: 105.75,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.51,
    y: 109.82,
    width: 101.45,
    height: 105.75,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,215.6H52.48V109.79H154Zm-101.45-.06H153.93V109.85H52.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.15,
    y: 124.04,
    width: 74.17,
    height: 77.32,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.15,201.87A12.2,12.2,0,0,1,64.32,204c-1.19,1.25-2.85,2.94-4.72,4.78s-3.58,3.47-4.84,4.64a11.3,11.3,0,0,1-2.15,1.78,12.44,12.44,0,0,1,1.82-2.12c1.19-1.25,2.86-2.94,4.73-4.79s3.59-3.48,4.85-4.64A11.33,11.33,0,0,1,66.15,201.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.32,201.68a12.2,12.2,0,0,1,2.13,1.83c1.25,1.18,2.94,2.85,4.78,4.72s3.48,3.58,4.64,4.84a11.86,11.86,0,0,1,1.78,2.14,11.36,11.36,0,0,1-2.12-1.82c-1.25-1.18-2.94-2.85-4.79-4.72s-3.48-3.59-4.64-4.86A11.64,11.64,0,0,1,140.32,201.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.12,124.24a11.66,11.66,0,0,1,1.83-2.13c1.18-1.25,2.85-2.94,4.71-4.77s3.58-3.48,4.85-4.64a11.84,11.84,0,0,1,2.14-1.79,11,11,0,0,1-1.82,2.12c-1.18,1.25-2.85,3-4.72,4.79s-3.59,3.48-4.86,4.65A11.27,11.27,0,0,1,140.12,124.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.94,124.43a12.27,12.27,0,0,1-2.12-1.83c-1.25-1.18-3-2.85-4.78-4.71s-3.48-3.58-4.64-4.85a12.41,12.41,0,0,1-1.79-2.14,11,11,0,0,1,2.12,1.82c1.25,1.18,3,2.85,4.79,4.72S63,121,64.17,122.3A11.27,11.27,0,0,1,65.94,124.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.12,201.36a3.18,3.18,0,0,1,0-.38c0-.26,0-.62,0-1.08,0-1,0-2.36,0-4.17,0-3.67,0-9-.07-15.76,0-13.54-.09-32.83-.15-55.93l.29.28-74,.05h0l.33-.33c0,28.38,0,54.93,0,77.32l-.28-.29,53.56.15,15,.07,4,0,1,0,.36,0h-.33l-1,0-3.92,0-15,.07-53.74.15h-.28v-.28c0-22.39,0-48.94-.05-77.32v-.33h.34l74,0h.29V124c-.06,23.17-.11,42.53-.14,56.11,0,6.74-.06,12-.08,15.7,0,1.78,0,3.16,0,4.11,0,.45,0,.8,0,1S140.12,201.36,140.12,201.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.86,
    y: 150.32,
    width: 24.75,
    height: 24.75,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 665.63,
    y: 116.08,
    width: 8.57,
    height: 42.66,
    transform: "translate(-0.73 3.59) rotate(-0.31)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 591.32,
    y: 116.23,
    width: 22.2,
    height: 23.55,
    transform: "translate(-0.68 3.23) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 613.41,
    y: 116.11,
    width: 22.2,
    height: 23.55,
    transform: "translate(-0.68 3.35) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.29,122.79c14.75.12,29.54,0,44.29-.2a.24.24,0,0,0,0-.47c-14.75-.09-29.54,0-44.29.27a.2.2,0,0,0,0,.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 577.46,
    y: 139.43,
    width: 40.33,
    height: 19.19,
    transform: "translate(-0.79 3.2) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 617.61,
    y: 139.22,
    width: 40.33,
    height: 19.19,
    transform: "translate(-0.79 3.42) rotate(-0.31)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.44,144.88c26.8.3,53.68,0,80.48-.4a.24.24,0,0,0,0-.47c-26.79-.14-53.68-.13-80.47.46a.21.21,0,0,0,0,.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.36,
    y: 158.73,
    width: 156.26,
    height: 6.88,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 587.94,
    y: 162.04,
    width: 6.34,
    height: 23.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682.63,
    y: 162.04,
    width: 6.34,
    height: 23.46,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 674.04,
    y: 100.17,
    width: 8.57,
    height: 58.67,
    transform: "translate(-0.68 3.63) rotate(-0.31)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 682.66,
    y: 111.11,
    width: 13.32,
    height: 47.54,
    transform: "matrix(1, -0.01, 0.01, 1, -0.71, 3.7)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.76,120.23a96.54,96.54,0,0,1-13.32,0,96.54,96.54,0,0,1,13.32,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.76,118.23a92.53,92.53,0,0,1-13.32,0,96.54,96.54,0,0,1,13.32,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.76,151.46a96.54,96.54,0,0,1-13.32,0,96.54,96.54,0,0,1,13.32,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.76,149.46a92.53,92.53,0,0,1-13.32,0,96.54,96.54,0,0,1,13.32,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.32,145.11c-.13,0-.24-4.8-.24-10.72s.11-10.71.24-10.71.23,4.8.23,10.71S689.44,145.11,689.32,145.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 695.91,
    y: 122.75,
    width: 14.5,
    height: 35.88,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.56,149.33a3.12,3.12,0,0,1-3.24-3.23,2.8,2.8,0,0,1,1.18-2.42l.33.45a2.32,2.32,0,0,0-1,2,2.69,2.69,0,0,0,5.38,0,2.31,2.31,0,0,0-1-2l.33-.45a2.81,2.81,0,0,1,1.17,2.42A3.12,3.12,0,0,1,703.56,149.33Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706,142.79l-.49-.28a3.76,3.76,0,0,0,.77-2.3c0-1.35-.48-1.89-1.2-1.89-1.86,0-.49,4.23-3,4.23-1,0-1.75-.8-1.75-2.42A3.9,3.9,0,0,1,701,138l.49.28a3.27,3.27,0,0,0-.58,1.92c0,1.24.52,1.79,1.2,1.79,1.92,0,.56-4.23,3-4.23,1,0,1.74.89,1.74,2.52A4,4,0,0,1,706,142.79Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706,136.94l-.49-.28a3.74,3.74,0,0,0,.77-2.3c0-1.34-.48-1.88-1.2-1.88-1.86,0-.49,4.23-3,4.23-1,0-1.75-.81-1.75-2.42a3.91,3.91,0,0,1,.63-2.19l.49.28a3.32,3.32,0,0,0-.58,1.92c0,1.25.52,1.8,1.2,1.8,1.92,0,.56-4.23,3-4.23,1,0,1.74.89,1.74,2.52A4,4,0,0,1,706,136.94Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.51,110.17A2.47,2.47,0,1,1,678,107.7,2.47,2.47,0,0,1,680.51,110.17Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 677.28,
    y: 116.94,
    width: 1.52,
    height: 34.9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.13,
    y: 363.65,
    width: 72.57,
    height: 5.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 647.77,
    y: 363.65,
    width: 19.93,
    height: 5.63,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.92,369.28v25.35h-4v2.75h4v17h74.3V398.91h-5.5v-3.36h5.5V390.5h2.45v-2.29h-2.91V369.28Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "640.49 369.35 640.49 414.07 660.22 414.07 660.22 398.63 654.72 398.63 654.72 395.55 660.22 395.55 660.22 390.5 662.67 390.5 662.67 387.93 659.76 387.93 659.76 369.28 640.49 369.35",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.89,397c0,.15-13.44.28-30,.28s-30-.13-30-.28,13.44-.28,30-.28S641.89,396.86,641.89,397Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.89,394.44c0,.16-13.44.29-30,.29s-30-.13-30-.29,13.44-.28,30-.28S641.89,394.29,641.89,394.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.75,387.51c0,.16-13.44.28-30,.28s-30-.12-30-.28,13.45-.28,30-.28S645.75,387.36,645.75,387.51Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.12,406.4c0,.16-13.44.28-30,.28s-30-.12-30-.28,13.45-.28,30-.28S646.12,406.25,646.12,406.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.35,419.73v25.35h-4v2.75h4v17h74.3V449.36h-5.5V446h5.5V441h2.45v-2.29h-2.91V419.73Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "648.92 419.8 648.92 464.52 668.65 464.52 668.65 449.08 663.14 449.08 663.14 446 668.65 446.1 668.65 441.06 671.14 441.06 671.1 438.45 668.19 438.38 668.19 419.73 648.92 419.8",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.32,447.47c0,.16-13.44.28-30,.28s-30-.12-30-.28,13.44-.28,30-.28S650.32,447.32,650.32,447.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.32,444.89c0,.16-13.44.29-30,.29s-30-.13-30-.29,13.44-.28,30-.28S650.32,444.74,650.32,444.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.18,438c0,.16-13.44.28-30,.28s-30-.12-30-.28,13.45-.28,30-.28S654.18,437.81,654.18,438Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.55,456.85c0,.16-13.44.28-30,.28s-30-.12-30-.28,13.45-.28,30-.28S654.55,456.7,654.55,456.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.27,318.57v25.35h-4v2.76h4v17h74.3V348.2h-5.5v-3.36h5.5v-5H670v-2.3h-2.91V318.57Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "647.84 318.64 647.84 363.36 667.57 363.36 667.57 347.92 662.07 347.92 662.07 344.84 667.57 344.94 667.57 339.9 670.06 339.9 670.02 337.3 667.11 337.22 667.11 318.57 647.84 318.64",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.24,346.31c0,.16-13.44.28-30,.28s-30-.12-30-.28,13.44-.28,30-.28S649.24,346.16,649.24,346.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.24,343.74c0,.15-13.44.28-30,.28s-30-.13-30-.28,13.44-.29,30-.29S649.24,343.58,649.24,343.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.1,336.8c0,.16-13.44.28-30,.28s-30-.12-30-.28,13.45-.28,30-.28S653.1,336.65,653.1,336.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.47,355.69c0,.16-13.44.28-30,.28s-30-.12-30-.28,13.44-.28,30-.28S653.47,355.54,653.47,355.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 590.27,
    y: 414.1,
    width: 72.57,
    height: 5.63,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 642.91,
    y: 414.1,
    width: 19.93,
    height: 5.63,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 140.49,
    y: 53.73,
    width: 488.22,
    height: 294.49,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.71,348.22c0-1.64-.08-114.06-.2-294.49l.2.21L140.52,54h0l.26-.26c0,104.33,0,203.89,0,294.49l-.24-.24,488.22.24-488.22.24h-.24v-.24c0-90.6,0-190.16,0-294.49v-.26h.29l488.19.06h.2v.2C628.79,234.16,628.71,346.58,628.71,348.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.36,103.69s-2.62,24,.75,37.16l32.09-1.4s-6.87-23.69-2.65-34.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.12,103.71s.22,25.92,1.54,33.84L238.18,136s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.52,114.6c0,.14-4.87.55-10.89.91s-10.92.54-10.93.4,4.87-.55,10.89-.92S231.51,114.45,231.52,114.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.53,120.09c0,.14-4.87.55-10.9.92s-10.91.54-10.92.39,4.87-.55,10.89-.91S231.52,120,231.53,120.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,125.48a38,38,0,0,1-6.2.64,38.5,38.5,0,0,1-6.23.11,37.37,37.37,0,0,1,6.2-.63A37.89,37.89,0,0,1,226,125.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.56,142.48s.22,25.93,1.54,33.84l32.52-1.54s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,153.37c0,.14-4.87.55-10.89.92s-10.92.54-10.93.39,4.87-.55,10.9-.91S231,153.23,231,153.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,158.86c0,.15-4.87.56-10.89.92s-10.92.54-10.93.39,4.87-.55,10.89-.91S231,158.72,231,158.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.44,164.25a36.69,36.69,0,0,1-6.2.64A37.17,37.17,0,0,1,213,165a37.37,37.37,0,0,1,6.2-.63A37.89,37.89,0,0,1,225.44,164.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.56,186.4s.22,25.92,1.54,33.84l32.52-1.54s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,197.29c0,.14-4.87.55-10.89.91s-10.92.54-10.93.4,4.87-.55,10.9-.92S231,197.14,231,197.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,202.78c0,.14-4.87.55-10.89.91s-10.92.54-10.93.4,4.87-.55,10.89-.91S231,202.64,231,202.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.44,208.17a37.37,37.37,0,0,1-6.2.63,37.89,37.89,0,0,1-6.23.12,37.37,37.37,0,0,1,6.2-.63A37.89,37.89,0,0,1,225.44,208.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.77,237.76s.22,25.93,1.54,33.84l32.52-1.54s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.17,248.65c0,.14-4.87.55-10.9.92s-10.92.54-10.93.39,4.87-.55,10.9-.91S227.16,248.51,227.17,248.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.18,254.14c0,.15-4.87.56-10.9.92s-10.92.54-10.93.4,4.87-.56,10.9-.92S227.17,254,227.18,254.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.65,259.54a38.69,38.69,0,0,1-6.2.63,35.89,35.89,0,0,1-6.23.11,38.51,38.51,0,0,1,6.2-.63A35.93,35.93,0,0,1,221.65,259.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.88,238s.22,25.93,1.54,33.84l32.52-1.53s-2.86-25.49-1.76-32.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.28,248.88c0,.14-4.87.55-10.9.91s-10.92.54-10.93.4,4.87-.56,10.9-.92S270.27,248.73,270.28,248.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.29,254.37c0,.14-4.87.55-10.9.91s-10.92.54-10.93.4,4.87-.55,10.9-.92S270.28,254.22,270.29,254.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.76,259.76a37.37,37.37,0,0,1-6.2.63,38,38,0,0,1-6.24.12,36.9,36.9,0,0,1,6.21-.64A38.5,38.5,0,0,1,264.76,259.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.94,239.84s.22,25.93,1.54,33.84L313,272.15s-2.86-25.49-1.76-32.31Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.34,250.73c0,.15-4.87.56-10.9.92s-10.92.54-10.93.4,4.87-.56,10.9-.92S306.33,250.59,306.34,250.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.35,256.23c0,.14-4.87.55-10.9.91s-10.92.54-10.93.4,4.87-.55,10.9-.92S306.34,256.08,306.35,256.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.82,261.62a37.37,37.37,0,0,1-6.2.63,38,38,0,0,1-6.24.12,36.9,36.9,0,0,1,6.21-.64A38.5,38.5,0,0,1,300.82,261.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.8,284.18s.22,25.93,1.54,33.84l32.52-1.54S268,291,269.1,284.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.2,295.07c0,.14-4.87.55-10.89.92s-10.92.54-10.93.39,4.87-.55,10.9-.91S264.19,294.93,264.2,295.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.21,300.56c0,.15-4.87.56-10.89.92s-10.92.54-10.93.39,4.87-.55,10.89-.91S264.2,300.42,264.21,300.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.68,306a36.52,36.52,0,0,1-6.2.64,37.17,37.17,0,0,1-6.23.11,37.37,37.37,0,0,1,6.2-.63A37.89,37.89,0,0,1,258.68,306Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.18,224.63s.22,25.93,1.54,33.84l32.52-1.54s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.58,235.52c0,.14-4.87.55-10.9.91s-10.91.54-10.92.4,4.87-.55,10.89-.92S368.57,235.37,368.58,235.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.59,241c0,.14-4.87.55-10.9.92s-10.92.54-10.92.39,4.86-.55,10.89-.91S368.58,240.87,368.59,241Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.06,246.4a36.69,36.69,0,0,1-6.2.64,38.5,38.5,0,0,1-6.23.11,37.37,37.37,0,0,1,6.2-.63A37.89,37.89,0,0,1,363.06,246.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.78,285.49s.22,25.93,1.54,33.84l32.52-1.53s-2.85-25.49-1.76-32.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.18,296.38c0,.15-4.87.56-10.89.92s-10.92.54-10.93.4,4.87-.56,10.9-.92S439.17,296.24,439.18,296.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.19,301.88c0,.14-4.87.55-10.89.91s-10.92.54-10.93.4,4.87-.55,10.9-.92S439.18,301.73,439.19,301.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.66,307.27a37.19,37.19,0,0,1-6.2.63,37.89,37.89,0,0,1-6.23.12,36.69,36.69,0,0,1,6.2-.64A38.47,38.47,0,0,1,433.66,307.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.92,286.05s.22,25.93,1.54,33.84L486,318.35s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.32,296.94c0,.14-4.87.55-10.9.91s-10.91.54-10.92.4,4.87-.55,10.89-.92S479.31,296.79,479.32,296.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.33,302.43c0,.14-4.87.55-10.9.92s-10.92.54-10.92.39,4.86-.55,10.89-.91S479.32,302.29,479.33,302.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.8,307.82a36.69,36.69,0,0,1-6.2.64,38.5,38.5,0,0,1-6.23.11,37.19,37.19,0,0,1,6.2-.63A37.89,37.89,0,0,1,473.8,307.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.06,286.6s.22,25.93,1.54,33.84l32.52-1.54s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.46,297.49c0,.14-4.87.55-10.9.92s-10.92.54-10.93.39,4.87-.55,10.9-.91S519.45,297.35,519.46,297.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.47,303c0,.15-4.87.56-10.9.92s-10.92.54-10.93.39,4.87-.55,10.9-.91S519.46,302.84,519.47,303Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.94,308.37a36.69,36.69,0,0,1-6.2.64,37.28,37.28,0,0,1-6.24.11,76.22,76.22,0,0,1,12.44-.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.31,285.08s.22,25.93,1.54,33.84l32.52-1.53s-2.85-25.49-1.76-32.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.71,296c0,.14-4.87.55-10.89.91s-10.92.54-10.93.4,4.87-.56,10.9-.92S567.7,295.83,567.71,296Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.72,301.47c0,.14-4.87.55-10.89.91s-10.92.54-10.93.4,4.87-.55,10.89-.92S567.71,301.32,567.72,301.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.19,306.86a37.19,37.19,0,0,1-6.2.63,37.89,37.89,0,0,1-6.23.12A36.69,36.69,0,0,1,556,307,38.47,38.47,0,0,1,562.19,306.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.29,288.83s.22,25.93,1.54,33.84l32.52-1.54s-2.85-25.49-1.75-32.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.69,299.72c0,.14-4.87.55-10.89.91s-10.92.54-10.93.4,4.87-.55,10.9-.92S602.69,299.57,602.69,299.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.7,305.21c0,.14-4.87.55-10.89.92s-10.92.54-10.93.39,4.87-.55,10.9-.91S602.69,305.07,602.7,305.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.17,310.6a36.52,36.52,0,0,1-6.2.64,38.5,38.5,0,0,1-6.23.11,37.37,37.37,0,0,1,6.2-.63A37.85,37.85,0,0,1,597.17,310.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.64,238.37s.22,25.93,1.53,33.84l32.53-1.54s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,249.26c0,.15-4.87.56-10.9.92s-10.92.54-10.93.39,4.87-.55,10.9-.91S439,249.12,439,249.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.05,254.75c0,.15-4.87.56-10.9.92s-10.92.54-10.93.4,4.87-.56,10.9-.92S439,254.61,439.05,254.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.52,260.15a38.69,38.69,0,0,1-6.2.63,36,36,0,0,1-6.24.11,38.92,38.92,0,0,1,6.21-.63A35.93,35.93,0,0,1,433.52,260.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.09,238.5s.22,25.93,1.54,33.84l32.52-1.54s-2.85-25.49-1.75-32.3Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.49,249.39c0,.14-4.87.55-10.89.91s-10.92.54-10.93.4,4.87-.55,10.9-.92S481.49,249.24,481.49,249.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.5,254.88c0,.14-4.87.55-10.89.92s-10.92.54-10.93.39,4.87-.55,10.9-.91S481.49,254.74,481.5,254.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476,260.27a36.9,36.9,0,0,1-6.21.64,38.5,38.5,0,0,1-6.23.11,37.37,37.37,0,0,1,6.2-.63A38,38,0,0,1,476,260.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.77,238.51s.22,25.93,1.54,33.84l32.52-1.54s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.17,249.4c0,.15-4.87.56-10.9.92s-10.92.54-10.92.4,4.87-.56,10.89-.92S565.16,249.26,565.17,249.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.18,254.9c0,.14-4.87.55-10.9.91s-10.92.54-10.93.4,4.87-.56,10.9-.92S565.17,254.75,565.18,254.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.65,260.29a37.37,37.37,0,0,1-6.2.63,37.89,37.89,0,0,1-6.23.12,36.52,36.52,0,0,1,6.2-.64A37.17,37.17,0,0,1,559.65,260.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.05,186.4s.22,25.92,1.54,33.84l32.52-1.54s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.45,197.29c0,.14-4.87.55-10.9.91s-10.92.54-10.92.4,4.86-.55,10.89-.92S281.44,197.14,281.45,197.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.46,202.78c0,.14-4.87.55-10.9.91s-10.92.54-10.93.4,4.87-.55,10.9-.91S281.45,202.64,281.46,202.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.93,208.17a37.37,37.37,0,0,1-6.2.63,37.85,37.85,0,0,1-6.23.12,37.19,37.19,0,0,1,6.2-.63A37.89,37.89,0,0,1,275.93,208.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.13,103.71s.22,25.92,1.54,33.84L275.19,136s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.53,114.6c0,.14-4.87.55-10.9.91s-10.92.54-10.93.4,4.87-.55,10.9-.92S268.52,114.45,268.53,114.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.54,120.09c0,.14-4.87.55-10.9.92s-10.92.54-10.93.39,4.87-.55,10.9-.91S268.53,120,268.54,120.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,125.48a38,38,0,0,1-6.2.64,38.61,38.61,0,0,1-6.24.11,37.58,37.58,0,0,1,6.21-.63A37.89,37.89,0,0,1,263,125.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.84,142.62s.22,25.93,1.54,33.84l32.52-1.53s-2.86-25.49-1.76-32.31Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.24,153.51c0,.15-4.87.56-10.9.92s-10.92.54-10.92.4,4.87-.56,10.89-.92S269.23,153.37,269.24,153.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.25,159c0,.14-4.87.55-10.9.91s-10.92.54-10.93.4,4.87-.55,10.9-.92S269.24,158.86,269.25,159Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.72,164.4a37.37,37.37,0,0,1-6.2.63,37.89,37.89,0,0,1-6.23.12,36.52,36.52,0,0,1,6.2-.64A38.5,38.5,0,0,1,263.72,164.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.66,103.71s.22,25.92,1.54,33.84L315.72,136s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.06,114.6c0,.14-4.87.55-10.9.91s-10.92.54-10.93.4,4.87-.55,10.9-.92S309.05,114.45,309.06,114.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.07,120.09c0,.14-4.87.55-10.9.92s-10.92.54-10.93.39,4.87-.55,10.9-.91S309.06,120,309.07,120.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.54,125.48a38,38,0,0,1-6.2.64,38.61,38.61,0,0,1-6.24.11,37.58,37.58,0,0,1,6.21-.63A37.89,37.89,0,0,1,303.54,125.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.19,103.71s.22,25.92,1.53,33.84L356.25,136s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.59,114.6c0,.14-4.87.55-10.9.91s-10.92.54-10.93.4,4.87-.55,10.9-.92S349.58,114.45,349.59,114.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.6,120.09c0,.14-4.87.55-10.9.92s-10.92.54-10.93.39,4.87-.55,10.9-.91S349.59,120,349.6,120.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.07,125.48a38,38,0,0,1-6.2.64,38.61,38.61,0,0,1-6.24.11,76.22,76.22,0,0,1,12.44-.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.72,103.71s.22,25.92,1.53,33.84L396.78,136s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.12,114.6c0,.14-4.87.55-10.9.91s-10.92.54-10.93.4,4.87-.55,10.9-.92S390.11,114.45,390.12,114.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.13,120.09c0,.14-4.87.55-10.9.92s-10.92.54-10.93.39,4.87-.55,10.9-.91S390.12,120,390.13,120.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.6,125.48a38,38,0,0,1-6.2.64,38.61,38.61,0,0,1-6.24.11,37.41,37.41,0,0,1,6.21-.63A37.89,37.89,0,0,1,384.6,125.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.89,109.45s.22,25.93,1.54,33.84L451,141.75s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.29,120.34c0,.14-4.87.55-10.9.92s-10.91.54-10.92.39,4.87-.55,10.89-.91S444.28,120.2,444.29,120.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.3,125.83c0,.15-4.87.56-10.9.92s-10.92.54-10.92.39,4.86-.55,10.89-.91S444.29,125.69,444.3,125.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.77,131.22a36.69,36.69,0,0,1-6.2.64,37.17,37.17,0,0,1-6.23.11,37.37,37.37,0,0,1,6.2-.63A37.89,37.89,0,0,1,438.77,131.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.18,110s.22,25.93,1.54,33.84l32.52-1.53s-2.86-25.49-1.76-32.31Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.58,120.89c0,.15-4.87.56-10.9.92s-10.92.54-10.93.4,4.87-.56,10.9-.92S480.57,120.75,480.58,120.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.59,126.39c0,.14-4.87.55-10.9.91s-10.92.54-10.93.4,4.87-.55,10.9-.92S480.58,126.24,480.59,126.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.06,131.78a37.37,37.37,0,0,1-6.2.63,38,38,0,0,1-6.24.12,36.9,36.9,0,0,1,6.21-.64A38.5,38.5,0,0,1,475.06,131.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.26,111.17s.22,25.92,1.53,33.84l32.53-1.54s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.66,122.06c0,.14-4.87.55-10.9.91s-10.92.54-10.93.4,4.87-.55,10.9-.92S520.65,121.91,520.66,122.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.67,127.55c0,.14-4.87.55-10.9.91s-10.92.55-10.93.4,4.87-.55,10.9-.91S520.66,127.41,520.67,127.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.14,132.94a37.37,37.37,0,0,1-6.2.63,38,38,0,0,1-6.24.12,76.22,76.22,0,0,1,12.44-.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.89,109.82s.22,25.93,1.54,33.84L575,142.12s-2.85-25.49-1.76-32.3Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.29,120.71c0,.15-4.87.56-10.89.92s-10.92.54-10.93.4,4.87-.56,10.9-.92S568.28,120.57,568.29,120.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.3,126.21c0,.14-4.87.55-10.89.91s-10.92.54-10.93.4,4.87-.56,10.89-.92S568.29,126.06,568.3,126.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.77,131.6a37.19,37.19,0,0,1-6.2.63,37.89,37.89,0,0,1-6.23.12,36.69,36.69,0,0,1,6.2-.64A37.17,37.17,0,0,1,562.77,131.6Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.85,152.09s.22,25.93,1.54,33.84l32.52-1.54s-2.85-25.49-1.75-32.3Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.25,163c0,.15-4.87.56-10.89.92s-10.92.54-10.93.4,4.87-.56,10.9-.92S572.25,162.84,572.25,163Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.26,168.48c0,.14-4.87.55-10.89.91s-10.92.54-10.93.4,4.87-.56,10.9-.92S572.26,168.33,572.26,168.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.74,173.87a76.22,76.22,0,0,1-12.44.75,36.69,36.69,0,0,1,6.2-.64A37.28,37.28,0,0,1,566.74,173.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.47,113.45s.22,25.93,1.54,33.84l32.52-1.54s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.87,124.34c0,.14-4.87.55-10.9.91s-10.92.54-10.93.4,4.87-.55,10.9-.92S596.86,124.19,596.87,124.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.88,129.83c0,.14-4.87.55-10.9.92s-10.92.54-10.93.39,4.87-.55,10.9-.91S596.87,129.69,596.88,129.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.35,135.22a36.69,36.69,0,0,1-6.2.64,38.61,38.61,0,0,1-6.24.11,76.22,76.22,0,0,1,12.44-.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.68,130.62s.22,25.93,1.53,33.84l32.53-1.54s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.08,141.51c0,.14-4.87.56-10.9.92s-10.92.54-10.93.39,4.87-.55,10.9-.91S453.07,141.37,453.08,141.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.09,147c0,.15-4.87.56-10.9.92s-10.92.54-10.93.4,4.87-.56,10.9-.92S453.08,146.86,453.09,147Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.56,152.4a38.69,38.69,0,0,1-6.2.63,36,36,0,0,1-6.24.11,38.92,38.92,0,0,1,6.21-.63A35.93,35.93,0,0,1,447.56,152.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.59,188.17s.21,25.93,1.53,33.84l32.53-1.54s-2.86-25.49-1.76-32.3Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,199.06c0,.14-4.87.55-10.9.91s-10.92.54-10.93.4,4.87-.55,10.9-.92S449,198.91,449,199.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,204.55c0,.14-4.87.55-10.89.92s-10.92.54-10.93.39,4.87-.55,10.9-.91S449,204.41,449,204.55Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.47,209.94a36.69,36.69,0,0,1-6.2.64,38.61,38.61,0,0,1-6.24.11,37.37,37.37,0,0,1,6.2-.63A38,38,0,0,1,443.47,209.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.66,131.85s2.63,24-.75,37.16l-32.09-1.4s6.88-23.69,2.66-34.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.65,127.77s-2,27.24-3.78,32.73l29.23,3.08,4.39-4.18s3.11-24,2.67-30.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.76 159.18 312.1 163.57 316.49 159.4 312.76 159.18",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.09,141.53a23.48,23.48,0,0,1-3.28-.39L302,140l-7.89-1a24.21,24.21,0,0,1-3.26-.48,18.81,18.81,0,0,1,3.3.11c2,.15,4.83.43,7.91.83s5.86.88,7.86,1.27A18.69,18.69,0,0,1,313.09,141.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.81,147.53a17.24,17.24,0,0,1-3.16-.11c-1.94-.14-4.63-.4-7.58-.78s-5.62-.79-7.54-1.13a17.44,17.44,0,0,1-3.09-.68,21.16,21.16,0,0,1,3.14.32l7.55,1,7.56.92A20.62,20.62,0,0,1,311.81,147.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,153.06a94.15,94.15,0,0,1-9.83-1.06,93.33,93.33,0,0,1-9.75-1.57,94.12,94.12,0,0,1,9.82,1.06A93.26,93.26,0,0,1,310,153.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.14,160.59s-2,27.24-3.78,32.73l29.23,3.08,4.39-4.18s3.11-24,2.67-30.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.25 192 242.59 196.4 246.98 192.22 243.25 192",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.58,174.35a20.21,20.21,0,0,1-3.28-.39l-7.86-1.11-7.89-1a20.75,20.75,0,0,1-3.26-.48,18.82,18.82,0,0,1,3.3.11c2,.15,4.83.43,7.91.84s5.86.87,7.86,1.26A19.94,19.94,0,0,1,243.58,174.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.31,180.36a18.09,18.09,0,0,1-3.17-.12c-1.94-.14-4.63-.4-7.58-.77s-5.62-.79-7.54-1.14a19.42,19.42,0,0,1-3.09-.67,18.72,18.72,0,0,1,3.14.31l7.55,1,7.56.93A19.43,19.43,0,0,1,242.31,180.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.48,185.88a95.62,95.62,0,0,1-9.83-1,91.65,91.65,0,0,1-9.75-1.58,93.84,93.84,0,0,1,9.82,1.06A93.26,93.26,0,0,1,240.48,185.88Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.99,
    y: 109.01,
    width: 24.42,
    height: 5.58,
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.99,
    y: 242.32,
    width: 24.42,
    height: 5.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.99,
    y: 287.43,
    width: 24.42,
    height: 5.58,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.17,
    y: 76.05,
    width: 84.3,
    height: 5.58,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.09,
    y: 76.05,
    width: 84.3,
    height: 5.58,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 548.26,
    y: 76.05,
    width: 40.26,
    height: 5.58,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.28,100c0,.15-98.83.27-220.73.27S157.8,100.13,157.8,100s98.82-.26,220.75-.26S599.28,99.84,599.28,100Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.28,232.68c0,.15-98.83.26-220.73.26s-220.75-.11-220.75-.26,98.82-.26,220.75-.26S599.28,232.54,599.28,232.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.28,323.76c0,.15-98.83.26-220.73.26s-220.75-.11-220.75-.26,98.82-.26,220.75-.26S599.28,323.62,599.28,323.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.28,279.36c0,.14-98.83.26-220.73.26s-220.75-.12-220.75-.26,98.82-.26,220.75-.26S599.28,279.21,599.28,279.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.22,325c-.15,0-.26-56.39-.26-125.95s.11-126,.26-126,.26,56.39.26,126S195.36,325,195.22,325Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.19,326.27c-.14,0-.26-56.31-.26-125.75s.12-125.75.26-125.75.26,56.29.26,125.75S399.33,326.27,399.19,326.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.28,327.59c-.14,0-.26-56.31-.26-125.76s.12-125.78.26-125.78.26,56.31.26,125.78S531.43,327.59,531.28,327.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.15,182.62l.39.14,1.16.48a22.31,22.31,0,0,1,4.07,2.51,23.27,23.27,0,0,1,5.16,5.53,25.53,25.53,0,0,1,2.28,4.16,26.12,26.12,0,0,1,1.53,5.09,23.73,23.73,0,0,1-1.06,12.06A26.22,26.22,0,0,1,455.74,224a25.4,25.4,0,0,1-14.19,5.7,27.73,27.73,0,0,1-16.06-3.44,27.2,27.2,0,0,1-11.11-12.09A23.77,23.77,0,0,1,412.57,199a24.09,24.09,0,0,1,6.7-12.13,20.65,20.65,0,0,1,5.18-3.66,22,22,0,0,1,5.52-2,34.45,34.45,0,0,1,10-.63,63,63,0,0,1,7.5,1c2,.38,3.61.75,4.68,1l1.2.29a2.56,2.56,0,0,1,.41.12l-.42-.06-1.22-.25c-1.07-.22-2.64-.55-4.68-.9a63.21,63.21,0,0,0-7.49-.92,34.24,34.24,0,0,0-9.9.69,22.38,22.38,0,0,0-5.42,1.95,20.67,20.67,0,0,0-5.06,3.62A23.59,23.59,0,0,0,413,199.07a23.33,23.33,0,0,0,1.8,14.85,26.81,26.81,0,0,0,10.91,11.86,27.35,27.35,0,0,0,15.76,3.38,24.92,24.92,0,0,0,13.93-5.56,25.94,25.94,0,0,0,7.84-11.16,23.34,23.34,0,0,0,1.09-11.84,25,25,0,0,0-1.46-5,26.3,26.3,0,0,0-2.22-4.13,23.65,23.65,0,0,0-5-5.53,24.14,24.14,0,0,0-4-2.58l-1.13-.52A2.05,2.05,0,0,1,450.15,182.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.66,185.74c-.09-.12,3.91-3.45,8.93-7.45s9.17-7.14,9.26-7-3.91,3.44-8.93,7.44S460.75,185.85,460.66,185.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476.45,186.35a6.32,6.32,0,0,1-1.28.18l-3.52.3c-3,.24-7.1.53-11.68.82l-.38,0,.11-.36c0-.14.09-.29.14-.44a45.38,45.38,0,0,1,5-10.93c.83-1.3,1.56-2.31,2.09-3a6.13,6.13,0,0,1,.88-1,7.65,7.65,0,0,1-.71,1.13c-.48.71-1.16,1.74-1.95,3.06a51.13,51.13,0,0,0-4.85,10.9l-.13.43-.26-.34c4.58-.29,8.7-.52,11.69-.66l3.53-.14A5.87,5.87,0,0,1,476.45,186.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589,248.76a21.77,21.77,0,0,1,.86-2.12,37.49,37.49,0,0,0-10.2-43,38.9,38.9,0,0,0-5-3.69c-1.25-.77-2-1.17-2-1.21a3.37,3.37,0,0,1,.54.24c.35.18.88.41,1.51.79a33.91,33.91,0,0,1,5.14,3.59,36.82,36.82,0,0,1,6.34,6.81,37.47,37.47,0,0,1,5.18,10.14,37.52,37.52,0,0,1,.67,20.48,34.48,34.48,0,0,1-2,5.92c-.29.68-.58,1.18-.75,1.53A3.94,3.94,0,0,1,589,248.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.22,243.09a23.12,23.12,0,0,1-2.64,2.31l-3,2.39-1.75,1.39a3.74,3.74,0,0,1-2.27,1.14,1.45,1.45,0,0,1-1.17-.8,5,5,0,0,1-.41-1.18c-.19-.75-.37-1.48-.55-2.17-.34-1.36-.64-2.6-.91-3.69a22.56,22.56,0,0,1-.71-3.43,22.64,22.64,0,0,1,1.06,3.33c.31,1.09.65,2.32,1,3.66.19.7.38,1.42.59,2.17s.43,1.56,1.11,1.59a3.43,3.43,0,0,0,1.92-1l1.78-1.37,3-2.3A24.66,24.66,0,0,1,598.22,243.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.34,182.33c0,.14-9.93,2.8-22.26,5.94s-22.36,5.56-22.4,5.42,9.93-2.79,22.27-5.93S343.31,182.19,343.34,182.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.79,187.63c0,.14-10.92,3.31-24.47,7.09s-24.58,6.73-24.61,6.59,10.91-3.31,24.47-7.09S349.76,187.49,349.79,187.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.73,196.39c0,.14-10.45,2.77-23.41,5.88s-23.49,5.5-23.53,5.36,10.45-2.76,23.41-5.87S353.7,196.25,353.73,196.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "298.32 287.96 306.27 329.98 385.7 314.94 371.89 274.03 298.32 287.96",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.52,
    y: 280.82,
    width: 76.56,
    height: 37.88,
    transform: "translate(-49.86 68.06) rotate(-10.72)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.94,311.25s-.06-.23-.15-.67-.22-1.1-.39-1.94c-.34-1.72-.83-4.22-1.45-7.43-1.25-6.43-3-15.71-5.25-27.14l.23.15-75.21,14.31h0l.21-.3c2.48,13.12,4.86,25.71,7,37.22l-.28-.2,54-10.1,15.6-2.89,4.18-.76,1.09-.19.38-.06a2.85,2.85,0,0,1-.35.09l-1,.21-4.12.81-15.53,3-54.13,10.37-.24,0,0-.24c-2.18-11.51-4.57-24.1-7.06-37.22l-.05-.25.26-.05h0l75.24-14.18.19,0,0,.19,5.06,27.3c.59,3.19,1,5.68,1.36,7.4.14.83.26,1.46.34,1.91S378.94,311.25,378.94,311.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.49,
    y: 292.92,
    width: 21.17,
    height: 21.17,
    transform: "translate(-50.9 64.46) rotate(-10.72)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.44,311.93a3.67,3.67,0,0,1-.1-.4c-.06-.3-.14-.67-.24-1.13-.21-1-.5-2.45-.86-4.24-.72-3.67-1.74-8.82-3-15l.27.18-20.79,4c-.05.07.39-.57.2-.3h0v.07l0,.09,0,.17.07.36.13.71.27,1.41c.17.94.35,1.86.52,2.78.35,1.84.68,3.63,1,5.38.65,3.49,1.27,6.79,1.83,9.82l-.26-.18,15-2.73,4.26-.75L330,312a2.32,2.32,0,0,1,.41-.05,1.35,1.35,0,0,1-.35.09l-1.09.24-4.19.85-15.12,3-.23,0,0-.22-1.88-9.81c-.33-1.74-.68-3.54-1-5.37-.17-.92-.35-1.85-.52-2.78l-.27-1.41-.14-.71-.06-.36,0-.18v-.15h0l.21-.31,20.8-3.9.23,0,0,.22c1.13,6.24,2.08,11.46,2.75,15.17.31,1.78.56,3.19.74,4.21.07.45.13.81.18,1.1A1.44,1.44,0,0,1,330.44,311.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.44,311.93s-.11-.54-.41-1.49a7.33,7.33,0,0,0-2.2-3.49l0,0a7.69,7.69,0,0,0-2.58-1.56,8,8,0,0,0-3.49-.4l-.47,0,.25-.39a5.26,5.26,0,0,0,.19-5,4.77,4.77,0,0,0-1.84-2.07,5,5,0,0,0-2.82-.65A5.3,5.3,0,0,0,314,298a4.56,4.56,0,0,0-1.62,2.63,5.33,5.33,0,0,0,1.71,5.19l.25.2-.27.16a9.19,9.19,0,0,0-3.14,3.2,9.79,9.79,0,0,0-1.2,3.28,13.56,13.56,0,0,0-.08,3.06,4.47,4.47,0,0,1-.18-.8,8.74,8.74,0,0,1,0-2.3,9.62,9.62,0,0,1,1.14-3.41,9.25,9.25,0,0,1,3.22-3.4l0,.36a5.75,5.75,0,0,1-1.92-5.65,5,5,0,0,1,1.77-2.92,5.81,5.81,0,0,1,3.35-1.25,5.48,5.48,0,0,1,3.11.73,5.26,5.26,0,0,1,2,2.3,5.73,5.73,0,0,1-.26,5.44l-.22-.35a8.34,8.34,0,0,1,3.68.48,7.81,7.81,0,0,1,2.67,1.7l0,0a7.24,7.24,0,0,1,2.19,3.72,7.72,7.72,0,0,1,.21,1.14C330.45,311.79,330.46,311.93,330.44,311.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.44,290.4l18-3.41",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.48,287a81.63,81.63,0,0,1-9,2,81.91,81.91,0,0,1-9.07,1.45,81,81,0,0,1,9-2A76.59,76.59,0,0,1,352.48,287Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.23,294.59l3.65-.69",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.88,293.9c0,.14-.77.41-1.77.6s-1.85.23-1.88.09.77-.41,1.78-.6S338.85,293.76,338.88,293.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.86,295.77c0,.14-7.17,1.63-16.07,3.31s-16.15,2.94-16.18,2.8,7.17-1.63,16.08-3.31S368.83,295.63,368.86,295.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.73,299.38c0,.14-7.21,1.63-16.16,3.33s-16.24,3-16.27,2.81,7.21-1.63,16.17-3.32S369.71,299.24,369.73,299.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370,303.68a6.38,6.38,0,0,1-1.24.33l-3.4.73c-2.87.59-6.85,1.38-11.25,2.21s-8.4,1.56-11.29,2.06l-3.43.56a5.22,5.22,0,0,1-1.27.14,6.77,6.77,0,0,1,1.23-.34l3.4-.72c2.88-.6,6.86-1.38,11.26-2.21s8.39-1.56,11.29-2.06l3.43-.57A5.42,5.42,0,0,1,370,303.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.19,286.31a.77.77,0,0,1,.2-.12l.6-.31a20.78,20.78,0,0,1,2.43-1A22.14,22.14,0,0,1,350,284a20.36,20.36,0,0,1,6.41,1.84,8.73,8.73,0,0,1,2.95,2.33,4.46,4.46,0,0,1,.9,3.88,6.49,6.49,0,0,1-2.47,3.39,20.14,20.14,0,0,1-3.73,2.21,35.17,35.17,0,0,1-8.58,2.94,20.83,20.83,0,0,1-9.07-.12,13.33,13.33,0,0,1-4-1.66,6.59,6.59,0,0,1-2.74-3.19,4.64,4.64,0,0,1,.44-4,9.63,9.63,0,0,1,2.55-2.75,25.12,25.12,0,0,1,5.86-3.18,26,26,0,0,1,9.45-1.69,21.9,21.9,0,0,1,2.61.2l.67.1.23.06h-.23l-.68-.06c-.59-.05-1.47-.1-2.6-.09a26.45,26.45,0,0,0-9.32,1.82,25.24,25.24,0,0,0-5.72,3.18,9.3,9.3,0,0,0-2.43,2.64,4.22,4.22,0,0,0-.38,3.57,6.18,6.18,0,0,0,2.56,2.93,12.67,12.67,0,0,0,3.88,1.58,20.39,20.39,0,0,0,8.84.11,35,35,0,0,0,8.45-2.89,19.77,19.77,0,0,0,3.65-2.14,6,6,0,0,0,2.31-3.12,4,4,0,0,0-.79-3.48,8.27,8.27,0,0,0-2.79-2.22,20.33,20.33,0,0,0-6.26-1.87,22.84,22.84,0,0,0-9.44.72A23.38,23.38,0,0,0,338,286l-.62.26C337.27,286.3,337.19,286.32,337.19,286.31Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.76,285.77a48,48,0,0,1,5.35-4.68,48.59,48.59,0,0,1,5.67-4.28,48,48,0,0,1-5.35,4.68A49.59,49.59,0,0,1,358.76,285.77Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.51,284.86a40.79,40.79,0,0,1-6.24,1.55l-.75.15-.4.08.09-.4a13.46,13.46,0,0,1,2.26-5.2c.13.06-1,2.25-1.76,5.33l-.3-.32.75-.15A39.4,39.4,0,0,1,365.51,284.86Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.29,289.41a97.79,97.79,0,0,1-9.9,1.78,99.36,99.36,0,0,1-10,1.27,96,96,0,0,1,9.9-1.79A94.18,94.18,0,0,1,354.29,289.41Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.74,281.41a4.62,4.62,0,1,1-5.4-3.68A4.62,4.62,0,0,1,331.74,281.41Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.19,286.92a4.64,4.64,0,0,1-3.82-7.26,4.56,4.56,0,0,1,3-2,4.24,4.24,0,0,1,.86-.08,4.64,4.64,0,0,1,4.56,3.78h0a4.64,4.64,0,0,1-3.69,5.42A4.46,4.46,0,0,1,327.19,286.92Zm0-9.24a4.08,4.08,0,0,0-.85.08,4.59,4.59,0,1,0,5.37,3.66h0A4.61,4.61,0,0,0,327.2,277.68Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.49,353.78c-7.68-11.74-7.38-28.89,1.78-39.51,2.85-3.29,6.82-6.15,11.16-5.78s8,4.18,9.37,8.43.88,8.85.09,13.23c-1.11,6.14-3,12.43-7.23,17s-9.7,9.63-15.17,6.64",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.91,409.88A17.53,17.53,0,0,1,91.8,390c1.76-1.44,4.07-2.55,6.27-2s3.75,2.89,4.06,5.2A14.49,14.49,0,0,1,101,400c-1.13,3.07-2.66,6.13-5.27,8.1s-6.25,3.81-8.8,1.77",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4,405.85a25.38,25.38,0,0,0-12.79-26.78c-2.92-1.52-6.52-2.42-9.47-.95s-4.46,5.19-4.22,8.56,1.85,6.47,3.64,9.33c2.5,4,5.57,7.91,9.84,9.92s10,3.56,13-.08",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.73,377.72c3.68-11.86-2.55-26.23-12.93-33-3.23-2.11-7.31-3.58-10.91-2.2S40.09,348,40,351.93s1.41,7.75,3.15,11.29c2.44,4.95,5.55,9.84,10.29,12.69s12.39,5.68,16.32,1.81",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.11,435.66a2.21,2.21,0,0,1-.12-.57c-.06-.43-.14-1-.24-1.66-.06-.36-.11-.76-.17-1.19s-.18-.91-.27-1.41c-.2-1-.4-2.17-.73-3.42-.15-.63-.31-1.29-.47-2s-.41-1.38-.62-2.11c-.4-1.47-1-3-1.53-4.62a91.64,91.64,0,0,0-4.58-10.15,89.62,89.62,0,0,0-5.93-9.42c-1.05-1.35-2-2.68-3-3.83L58,393.62l-1.38-1.49c-.86-1-1.72-1.78-2.45-2.5l-1-1-.9-.8L51,386.71c-.28-.26-.43-.4-.41-.42a3.51,3.51,0,0,1,.47.34l1.31,1.05.93.77,1.06,1c.76.7,1.63,1.49,2.52,2.45l1.41,1.48L59.77,395c1,1.13,2,2.46,3.06,3.81a84.06,84.06,0,0,1,6,9.47,84,84,0,0,1,4.57,10.22c.54,1.64,1.11,3.17,1.5,4.66.2.74.4,1.45.59,2.13s.31,1.36.45,2c.31,1.27.49,2.43.65,3.45.09.51.16,1,.24,1.42s.08.84.12,1.21c.06.68.11,1.23.15,1.67A2.32,2.32,0,0,1,77.11,435.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.84,437.79a.68.68,0,0,1,0-.23c0-.19,0-.41,0-.69q.09-1,.24-2.64c.06-.57.12-1.21.19-1.9s.07-1.45.12-2.27c.06-1.62.21-3.48.16-5.53,0-1,0-2.1,0-3.22s-.12-2.28-.17-3.48c-.08-2.42-.41-5-.7-7.67a120.91,120.91,0,0,0-3.64-17.24,121,121,0,0,0-6.35-16.44c-1.23-2.41-2.35-4.74-3.59-6.8-.61-1-1.16-2.08-1.76-3L59.63,364c-1.07-1.75-2.21-3.22-3.15-4.55-.48-.66-.91-1.28-1.33-1.84L54,356.07,52.32,354l-.42-.54a1.08,1.08,0,0,1-.13-.2s.06.05.17.16l.45.52,1.72,2,1.23,1.46c.43.55.88,1.17,1.37,1.82,1,1.32,2.12,2.78,3.22,4.53l1.77,2.7c.61.94,1.17,2,1.79,3,1.27,2.06,2.4,4.39,3.65,6.81a117.07,117.07,0,0,1,6.41,16.5,117.93,117.93,0,0,1,3.62,17.32c.27,2.71.59,5.28.65,7.7.05,1.21.15,2.38.15,3.5s0,2.2,0,3.23c0,2.06-.15,3.92-.23,5.55-.06.82-.09,1.58-.16,2.27s-.16,1.33-.23,1.9c-.14,1.11-.26,2-.34,2.63,0,.28-.07.5-.1.68S76.85,437.79,76.84,437.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.82,322.66s0,.08-.1.22l-.33.61-1.31,2.35c-.29.51-.62,1.06-1,1.69l-1,2.06L91.92,332c-.4.85-.78,1.77-1.2,2.72s-.87,1.94-1.3,3L88.15,341c-.22.57-.45,1.15-.67,1.74s-.41,1.21-.62,1.83q-.63,1.84-1.29,3.81c-1.62,5.26-3.16,11.11-4.46,17.33s-2.15,12.23-2.8,17.7-1,10.42-1.09,14.58c-.1,2.08-.12,4-.13,5.62s0,3.08,0,4.25,0,2,0,2.68v.7a.64.64,0,0,1,0,.24.75.75,0,0,1,0-.24c0-.18,0-.41,0-.69,0-.66-.07-1.55-.13-2.69s-.09-2.59-.09-4.25,0-3.54.06-5.63c.07-4.17.44-9.13,1-14.63s1.5-11.49,2.76-17.74,2.87-12.11,4.52-17.37c.45-1.31.89-2.58,1.31-3.82q.33-.93.63-1.83l.69-1.74,1.3-3.3c.44-1.06.91-2,1.33-3s.83-1.86,1.24-2.71l1.22-2.36c.39-.73.74-1.41,1.07-2s.69-1.17,1-1.67l1.39-2.3.37-.59C96.76,322.72,96.81,322.65,96.82,322.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.21,394.68a10.77,10.77,0,0,1-.82,1.43c-.56.89-1.33,2.22-2.23,3.88s-1.9,3.68-2.91,6-2,4.87-2.82,7.62-1.48,5.43-2,7.88-.78,4.68-1,6.56-.3,3.41-.34,4.47a9.89,9.89,0,0,1-.14,1.64,12,12,0,0,1-.06-1.65c0-1.06,0-2.6.19-4.49a63.92,63.92,0,0,1,.86-6.62A72.91,72.91,0,0,1,85,413.42a75,75,0,0,1,2.88-7.65,63.77,63.77,0,0,1,3-5.95c1-1.65,1.77-2.95,2.38-3.82A9.52,9.52,0,0,1,94.21,394.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.04 430.38 95.75 430.38 91.67 464.81 66.24 464.81 62.04 430.38",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.27 461.09 66.14 464.81 91.67 464.81 94.61 461.21 63.27 461.09",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.43,440.5c0,.14-7,.26-15.62.26s-15.62-.12-15.62-.26,7-.25,15.62-.25S94.43,440.37,94.43,440.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.43,442.8c0,.14-7,.25-15.62.25s-15.62-.11-15.62-.25,7-.25,15.62-.25S94.43,442.66,94.43,442.8Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,445c0,.13-6.75.25-15.07.25s-15.08-.12-15.08-.25,6.75-.26,15.08-.26S94,444.88,94,445Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.19,356.18a1.45,1.45,0,0,1,0,.33c0,.26,0,.56-.08.94-.09.86-.2,2-.35,3.43-.3,2.89-.75,6.89-1.27,11.3,0,.17,0,.34-.06.49v.15h-.15c-4.33.07-8.23.11-11,.13H50a1.3,1.3,0,0,1-.31,0,.92.92,0,0,1,.31,0l.9-.05,3.33-.1c2.81-.08,6.71-.16,11-.23l-.17.15c0-.15,0-.32.06-.49.52-4.41,1-8.4,1.37-11.29.19-1.4.34-2.56.46-3.42,0-.37.1-.67.14-.92A1.12,1.12,0,0,1,67.19,356.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.53,345.89a1.3,1.3,0,0,1,0,.34c0,.26,0,.58,0,1,0,.89,0,2.1,0,3.56,0,3-.13,7.14-.24,11.71,0,.19,0,.37,0,.54v.18H59.1a105,105,0,0,0-11.34-.26c-1.44,0-2.61.11-3.41.15l-.93,0h-.33a1.43,1.43,0,0,1,.32-.06l.93-.11c.8-.08,2-.18,3.41-.25a89,89,0,0,1,11.37.15l-.18.17c0-.18,0-.36,0-.55.11-4.57.23-8.71.34-11.71.06-1.46.1-2.66.14-3.55,0-.39,0-.7,0-1A1.38,1.38,0,0,1,59.53,345.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.56,342.38a7.53,7.53,0,0,1,.21,1c.13.7.29,1.61.5,2.71.43,2.29,1.12,5.44,2.08,8.89l.1.37-.34-.17L52.7,355a29.12,29.12,0,0,0-9-2.63c-1.2-.15-2.17-.2-2.85-.23a8.63,8.63,0,0,1-1-.05s.09,0,.27,0,.44,0,.78,0a23,23,0,0,1,2.87.12,27.42,27.42,0,0,1,9.1,2.56l.41.2-.24.2a88.24,88.24,0,0,1-2-8.95c-.19-1.15-.32-2.08-.39-2.73A4.48,4.48,0,0,1,50.56,342.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.15,405.14c0,.06-1,0-2.54-.11a43.81,43.81,0,0,0-6.13.2c-.49,0-1,.11-1.42.18l-.16,0,0-.16c-.37-2-.67-3.83-.88-5.12a12.87,12.87,0,0,1-.26-2.08,14.1,14.1,0,0,1,.48,2c.26,1.28.61,3.06,1,5.1l-.19-.14c.45-.06.93-.13,1.42-.18a35.41,35.41,0,0,1,6.18-.1c.79.06,1.42.14,1.86.21A2.75,2.75,0,0,1,98.15,405.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34,398.82c0,.05-1-.17-2.47-.36a27.64,27.64,0,0,0-6-.06l-1.06.14-.17,0,0-.17c-.21-2.1-.39-4-.49-5.29A13.22,13.22,0,0,1,91,391a15.8,15.8,0,0,1,.33,2.13c.17,1.32.38,3.18.61,5.27l-.2-.15c.34-.05.7-.1,1.07-.13a22.83,22.83,0,0,1,6.05.16,18.2,18.2,0,0,1,1.8.37A2.83,2.83,0,0,1,101.34,398.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.62,338.89a1.37,1.37,0,0,1-.33.17l-1,.44-3.64,1.55-12.08,5-.65.26-.15.07-.07-.16-5.1-11.52-1.5-3.48-.39-1a1.55,1.55,0,0,1-.12-.34,1.34,1.34,0,0,1,.18.31c.12.24.26.55.45.93.39.85.93,2,1.6,3.44L86,346.09,85.8,346l.65-.27,12.12-4.91,3.68-1.45,1-.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.57,324.33s-.09.08-.29.22l-.89.57-3.29,2.05-11,6.69L91,334l-.07-.19c-.07-.17-.13-.35-.2-.53l-4.6-12.42c-.56-1.56-1-2.84-1.36-3.77l-.35-1c-.08-.24-.12-.37-.1-.37a1.68,1.68,0,0,1,.16.34c.11.27.25.6.41,1,.37.93.86,2.2,1.46,3.74,1.22,3.21,2.87,7.57,4.7,12.38l.2.53-.25-.09,11-6.6,3.35-2,.91-.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.61,316.56a4.4,4.4,0,0,1-.73.43c-.47.26-1.16.65-2,1.16a36.07,36.07,0,0,0-6.11,4.78l-.42.42.14-.58c.15-.6.29-1.24.39-1.89a22.25,22.25,0,0,0-.47-9,26.11,26.11,0,0,0-.87-2.61,7.83,7.83,0,0,1-.36-.95,5.06,5.06,0,0,1,.48.9,20.8,20.8,0,0,1,1,2.6,21.16,21.16,0,0,1,.58,9.1c-.11.66-.25,1.31-.4,1.92l-.28-.16a31.84,31.84,0,0,1,6.23-4.73c.85-.49,1.56-.85,2-1.08A3.73,3.73,0,0,1,105.61,316.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.15,392.14A5.47,5.47,0,0,1,67,393c-.12.55-.29,1.36-.47,2.37a57.76,57.76,0,0,0-.9,8v.15h-.15l-.76.05c-3.34.2-6.37.36-8.56.46l-2.6.11a6.36,6.36,0,0,1-.95,0,4.34,4.34,0,0,1,.95-.13l2.59-.21c2.18-.16,5.21-.36,8.55-.56l.76-.05-.16.16a49.59,49.59,0,0,1,1-8c.22-1,.42-1.8.58-2.35A3.19,3.19,0,0,1,67.15,392.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.52,382.64a5.27,5.27,0,0,1-.05.88c-.07.62-.17,1.43-.28,2.39-.24,2-.6,4.85-1,8l0,.13H59l-1.08.07c-3.43.24-6.52.59-8.75.88l-2.64.35a4.37,4.37,0,0,1-1,.1,5.87,5.87,0,0,1,.95-.23c.62-.12,1.52-.28,2.63-.46,2.23-.35,5.32-.74,8.75-1l1.09-.07-.16.15c.44-3.16.84-6,1.15-8,.15-1,.27-1.76.37-2.38A5.44,5.44,0,0,1,60.52,382.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.73,378.55c.05,0-.16.93-.4,2.43a42.87,42.87,0,0,0-.54,6v.19l-.19,0L51,387a51.73,51.73,0,0,0-6.37-.38l-1.93,0a3.67,3.67,0,0,1-.72,0,2.36,2.36,0,0,1,.71-.12c.46-.05,1.12-.1,1.94-.13a40.9,40.9,0,0,1,6.41.28l.57.07-.19.17a35,35,0,0,1,.65-6c.15-.75.3-1.35.41-1.76A2.32,2.32,0,0,1,52.73,378.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.13,388.05a28.6,28.6,0,0,1-1.5,3.42A28.33,28.33,0,0,1,94,394.83a25.25,25.25,0,0,1,3.12-6.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.37,392.53a36,36,0,0,0-3.83.78,34.42,34.42,0,0,0-3.6,1.53,8.66,8.66,0,0,1,3.5-1.86A8.87,8.87,0,0,1,101.37,392.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.72,428.33c4.17-2.15,9.08-2.43,13.7-1.66,2.49.41,5.08,1.15,6.77,3s2,5.15.07,6.75a6.5,6.5,0,0,1-4.27,1.09c-3.62,0-7.64-.68-10.53,1.5-1.65,1.24-2.75,3.31-4.72,3.92a4.67,4.67,0,0,1-5.14-2.29,8,8,0,0,1-.58-5.88A9,9,0,0,1,684.72,428.33Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.17,409.9c2.55,3.64,7.51,2.43,9.8.21s3.27-5.44,4.15-8.51c2-7,4.06-14.38,2.56-21.52a11.94,11.94,0,0,0-2.75-5.85,6.25,6.25,0,0,0-5.92-2c-2.5.66-4,3.11-5.17,5.43a51.18,51.18,0,0,0-5.07,22c0,3.54.4,7.26,2.4,10.19",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.18,415.12c2.76-3.28,3.29-8.07,2.06-12.19A23.56,23.56,0,0,0,663,392.46a38.87,38.87,0,0,0-12.93-7.62,13.71,13.71,0,0,0-5.81-1,6.12,6.12,0,0,0-4.88,2.95c-1.36,2.59,0,5.74,1.36,8.31A97.62,97.62,0,0,0,649.25,408c2.54,3.28,5.46,6.51,9.33,8s7.91,1.31,10-1.38",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675,464.8a7.14,7.14,0,0,0,.23-1.65c.12-1.2.27-2.72.44-4.51a65.06,65.06,0,0,1,1-6.63,51.38,51.38,0,0,1,2.4-7.81,29,29,0,0,1,4-7.07,14.75,14.75,0,0,1,5-4.19,14,14,0,0,1,4.25-1.33,8.22,8.22,0,0,0,1.64-.23,7.19,7.19,0,0,0-1.67,0,12.77,12.77,0,0,0-4.43,1.15,14.76,14.76,0,0,0-5.32,4.23,28,28,0,0,0-4.14,7.22,46.89,46.89,0,0,0-2.39,7.94,56.11,56.11,0,0,0-.88,6.7c-.14,1.92-.2,3.47-.22,4.54A8,8,0,0,0,675,464.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.31,461.33a2.92,2.92,0,0,0,.05-.77c0-.57,0-1.3,0-2.19,0-1.91,0-4.66.1-8.07.17-6.8.75-14.13,1.89-24.46,1.07-9.71,2.51-21,4-28.36.33-1.67.66-3.17,1-4.49s.54-2.46.79-3.38.37-1.57.51-2.13a3.24,3.24,0,0,0,.13-.76,3.67,3.67,0,0,0-.26.72c-.17.55-.38,1.25-.64,2.11s-.57,2-.9,3.35-.71,2.81-1.07,4.48a249.36,249.36,0,0,0-4.23,26.32c-1.14,10.35-1.65,19.77-1.69,26.59,0,3.42,0,6.18.12,8.08,0,.9.09,1.62.13,2.2A3.83,3.83,0,0,0,675.31,461.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.36,443.16a14,14,0,0,0,0-2.3,60.76,60.76,0,0,0-.7-6.21,81.17,81.17,0,0,0-2-9,74.44,74.44,0,0,0-3.78-10.7,57,57,0,0,0-11.12-17.31,29.35,29.35,0,0,0-2.61-2.43c-.4-.34-.76-.68-1.12-.94l-1-.7a14.64,14.64,0,0,0-1.93-1.24,68.05,68.05,0,0,1,6.32,5.65,59.83,59.83,0,0,1,10.84,17.24A83.65,83.65,0,0,1,672,425.78a90.14,90.14,0,0,1,2.14,9c.48,2.59.75,4.69.92,6.15A13.6,13.6,0,0,0,675.36,443.16Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.57,174.18c0,5.94,7.82,9.8,7.53,15.73-.13,2.55-1.78,4.79-2.17,7.31-.53,3.38,1.27,6.66,1.86,10,1.22,7-3,14.12-9.11,17.71s-13.59,4.07-20.55,2.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.83,171.19c.13,3.19-2.06,6-4.26,8.29s-4.64,4.74-5.2,7.89c-1,5.58,4.33,11,3,16.47-.7,2.95-3.21,5.26-3.74,8.25s1,5.79,2.81,8.06,4.1,2,5.73,4.47a24.24,24.24,0,0,0,7.19,6.82c6,3.56,13.58-1.07,16.58-1.85",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.65,177.64c.17-2.89-2.43-5.21-5.08-6.35s-5.64-1.64-8-3.34c-2.08-1.49-3.44-3.77-5.17-5.65a17.81,17.81,0,0,0-30.2,7.2c-1.16,4.09-.61,9,2.54,11.81,3.67,3.3,9.27,2.77,14.13,1.94s10.35-1.63,14.28,1.33c2.38,1.79,3.68,4.61,5.08,7.23s3.18,5.31,6,6.37,6.64-.49,6.85-3.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.67,176.57l-25.44-7.37c-8.19-1.15-14,8.78-14.8,17-.9,9.15-1.63,20.34-.78,27.22,1.72,13.82,12.19,15.93,12.19,15.93s-.12,4-.26,8.93a14.76,14.76,0,0,0,14,15.18h0a14.77,14.77,0,0,0,15.45-13.79l3.74-58.06A4.84,4.84,0,0,0,549.67,176.57Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.19,196.25a1.76,1.76,0,0,0,1.63,1.84,1.7,1.7,0,0,0,1.88-1.53,1.77,1.77,0,0,0-1.64-1.84A1.69,1.69,0,0,0,511.19,196.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.22,193.42c.21.24,1.58-.71,3.48-.64s3.25,1.07,3.47.85-.11-.53-.7-1a4.85,4.85,0,0,0-2.76-1,4.67,4.67,0,0,0-2.78.8C511.33,192.9,511.12,193.31,511.22,193.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.69,196.75a1.76,1.76,0,0,0,1.64,1.83,1.67,1.67,0,0,0,1.87-1.52,1.76,1.76,0,0,0-1.64-1.84A1.69,1.69,0,0,0,529.69,196.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.86,194.41c.21.24,1.58-.7,3.48-.63s3.25,1.07,3.47.84-.11-.52-.7-1a4.78,4.78,0,0,0-2.77-1,4.68,4.68,0,0,0-2.77.79C530,193.9,529.76,194.31,529.86,194.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.49,208.25a12.53,12.53,0,0,0-3.06-.66c-.48-.07-.94-.18-1-.52a2.49,2.49,0,0,1,.37-1.42l1.56-3.64c2.17-5.18,3.76-9.45,3.55-9.54s-2.14,4.05-4.31,9.23l-1.5,3.67a2.76,2.76,0,0,0-.31,1.89,1.19,1.19,0,0,0,.77.73,3.5,3.5,0,0,0,.82.15A12.1,12.1,0,0,0,522.49,208.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.84,229.36a33.2,33.2,0,0,0,18.4-4.09c-.16,0-5.38,9.4-18.51,7.53Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.14,212.85a3.43,3.43,0,0,1,3.1-1.17,3.18,3.18,0,0,1,2.12,1.23,2,2,0,0,1,.07,2.27,2.29,2.29,0,0,1-2.51.54,7.09,7.09,0,0,1-2.37-1.53,2,2,0,0,1-.52-.58.63.63,0,0,1,0-.7",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528,209.75c-.31,0-.38,2-2.2,3.43s-4,1.1-4,1.39c0,.13.48.42,1.4.47a5.08,5.08,0,0,0,3.36-1,4.48,4.48,0,0,0,1.7-2.88C528.38,210.26,528.17,209.75,528,209.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.12,191.06c.17.53,2.07.35,4.29.69s4,1,4.31.56c.14-.21-.16-.71-.87-1.23a7.18,7.18,0,0,0-3.16-1.24,7.3,7.3,0,0,0-3.39.28C529.47,190.42,529.05,190.82,529.12,191.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.11,188c.32.44,1.64,0,3.21.08s2.9.38,3.22-.06c.14-.21-.06-.65-.62-1.08a4.47,4.47,0,0,0-2.59-.79,4.33,4.33,0,0,0-2.59.78C512.17,187.3,512,187.74,512.11,188Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.57,224.05c-3.8.64-4.08-1.3-6.82-4a12.39,12.39,0,0,1-3.46-10.59c.53-3.37,2.47-6.74,1.4-10-1.41-4.27-7.3-5.76-8.73-10-.84-2.48.08-5.32-.88-7.75s-3.24-3.67-5.52-4.58-4.75-1.57-6.64-3.14-3-4.46-1.7-6.54A130.13,130.13,0,0,1,551,175.69c2.22.91,4.54,2,5.81,4s1.18,4.88,1,7.41q-1.47,18.48-2.92,37",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.12,196.28a10.56,10.56,0,0,1,20.09-3c1.79,3.94,1,8.64-.94,12.53-2.27,4.62-6.75,8.76-11.88,8.36-4.83-.37-8.58-4.74-9.82-9.42s-.53-9.63.2-14.42",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.21,215.19a2.38,2.38,0,0,0,.75-.77,6.8,6.8,0,0,0,1.11-2.72,13.4,13.4,0,0,0,0-4.35c-.23-1.62-.72-3.34-1.06-5.15a12.82,12.82,0,0,1-.14-5.1c.33-1.52,1.09-2.8,1.45-4a5.2,5.2,0,0,0,.18-2.94,1.77,1.77,0,0,0-.51-1s.16.35.28,1a5.5,5.5,0,0,1-.36,2.75,34.65,34.65,0,0,0-1.58,4,12.81,12.81,0,0,0,.08,5.33c.35,1.85.86,3.56,1.1,5.13a13.67,13.67,0,0,1,.12,4.19A8.75,8.75,0,0,1,565.21,215.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.94,198.69a6.69,6.69,0,0,0,2,2.13,12.09,12.09,0,0,0,13.58.68,6.74,6.74,0,0,0,2.25-1.92c-.07-.08-.89.7-2.46,1.54a12.9,12.9,0,0,1-6.65,1.53,13,13,0,0,1-6.47-2.18C566.75,199.48,566,198.62,565.94,198.69Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.55,200.87a6.28,6.28,0,0,0,1.1,2.19,15,15,0,0,0,9.77,6.31,6.41,6.41,0,0,0,2.45.1,22.1,22.1,0,0,0-2.37-.51,17.26,17.26,0,0,1-9.51-6.15A20.15,20.15,0,0,0,566.55,200.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.48,219.71s.06-.05.16-.16A4.07,4.07,0,0,0,563,219a7.31,7.31,0,0,0,1-2.37,8.56,8.56,0,0,0-.09-4.07,7.79,7.79,0,0,0-3.06-4.41c-1.6-1.2-3.7-2.07-5-3.94a4.16,4.16,0,0,1-.64-3.26,18.6,18.6,0,0,1,1.31-3.53,10.27,10.27,0,0,0,.09-8.21,9,9,0,0,0-2.68-3.56,11,11,0,0,0-4.16-1.88c-1.48-.39-3-.63-4.32-1.09a8.59,8.59,0,0,1-3.58-2.11,6,6,0,0,1-1.47-3.66,29.86,29.86,0,0,0-.52-4,13.71,13.71,0,0,0-3.5-6.62,10.83,10.83,0,0,0-5.75-3.09,8.74,8.74,0,0,0-5.34.63,8.42,8.42,0,0,0-3.16,2.57,7.13,7.13,0,0,0-1.15,2.3,3.58,3.58,0,0,0-.16.88,8.84,8.84,0,0,1,1.5-3,8.27,8.27,0,0,1,8.23-2.92,10.43,10.43,0,0,1,5.47,3,13.38,13.38,0,0,1,3.32,6.39,32.38,32.38,0,0,1,.49,4,6.59,6.59,0,0,0,1.6,4,9.08,9.08,0,0,0,3.83,2.28c1.43.48,2.91.72,4.36,1.11a10.31,10.31,0,0,1,3.94,1.77,8.44,8.44,0,0,1,2.5,3.31,9.71,9.71,0,0,1-.05,7.77,17.92,17.92,0,0,0-1.32,3.65,4.65,4.65,0,0,0,.75,3.63c1.44,2,3.6,2.86,5.14,4a7.37,7.37,0,0,1,3,4.15,8.39,8.39,0,0,1,.19,3.93A9.2,9.2,0,0,1,562.48,219.71Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M562.8,181.3a1.67,1.67,0,0,0,.19-.63,3,3,0,0,0-.4-1.84,4.71,4.71,0,0,0-2.24-2,7.14,7.14,0,0,0-3.94-.25c-1.45.22-3,.75-4.61,1a6.09,6.09,0,0,1-4.95-.94c-1.42-1.16-2.1-3.1-2.78-5a20.53,20.53,0,0,0-3-5.77,19,19,0,0,0-10.19-7.06,10.91,10.91,0,0,0-5.5,0,8.52,8.52,0,0,0-4.1,2.47,6.33,6.33,0,0,0-1.64,3.59,6.12,6.12,0,0,0,.36,3,4.77,4.77,0,0,0,1,1.61,2.08,2.08,0,0,0,.5.43,6.5,6.5,0,0,1-1.26-2.12,6.17,6.17,0,0,1,1.37-6.18,8.22,8.22,0,0,1,3.92-2.28,10.49,10.49,0,0,1,5.24.09,18.66,18.66,0,0,1,9.84,6.89,20.13,20.13,0,0,1,2.92,5.6c.7,1.92,1.38,4,3,5.28a5.21,5.21,0,0,0,2.68,1.1,9.29,9.29,0,0,0,2.7-.1c1.71-.3,3.2-.85,4.6-1.09a6.83,6.83,0,0,1,3.74.15,4.45,4.45,0,0,1,2.17,1.78,3.05,3.05,0,0,1,.48,1.71C562.85,181.08,562.76,181.29,562.8,181.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.21,289s-7.61-11.9-8.94-12.9-13.15-5.1-14.15-4.77-15.19,3-13.53,4.67,11.56-.34,11.56-.34l1.34.64s-8.55,1.51-10.34,2.59c-1.64,1-1,3,.53,2.82s9-1.75,9.44-1.46-8.07,2.15-9,2.71c-1.23.75-1.31,3,.25,2.82.92-.08,8.94-2.29,8.94-2.29s-6.35,2.56-6.93,3.13c-.95.94-.16,2.31,1.22,2,.95-.23,5.43-2.46,6.7-2.76,0,0,1.19.3,2.31,2.69.52,1.12,2.93,8.08,7.13,7.92,3.71-.14,7.41,2.86,7.41,2.86Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.62,276a6.7,6.7,0,0,0,2.61.68,15.28,15.28,0,0,0,2.93.07c1.09-.14,2.27-.33,3.52-.52l2.65-.43h-.16a38.58,38.58,0,0,0,6.17,1.82,38.93,38.93,0,0,0-6-2.43l-.08,0-.09,0-2.62.4-3.48.57a19.91,19.91,0,0,1-2.84.06C416.64,276.15,415.65,275.93,415.62,276Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.6,246s-8.07,4.89-11,10.93-18.46,46.53-18.46,46.53L452.2,284.17l-9.76,16.65L479.13,330a24.11,24.11,0,0,0,16.32,3.35h0c8.78-1.32,13.09-1.52,16.11-9.87l9.76-27-2.08-49.53",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M509.67,269.66c-9,13-10.46,19.14-11.41,34.92-.32,5.24,0,10.89,3.12,15.08,1.14,1.53,3.37,2.84,4.84,1.62s.41-3.39-.07-5.2c-2.79-10.61-3.78-18.78-1.8-28.12s1.47-9.17,5.32-17.91"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M495.82,319.68a36.8,36.8,0,0,0-4.89-16.21,8.4,8.4,0,0,1,1.46,2.06,26.33,26.33,0,0,1,3.5,11.62A8.77,8.77,0,0,1,495.82,319.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.7,366.67,503,464.49h93.23s-2.76-49-6.23-69.93c-3.63-37-15.17-42.48-23.27-60.33l4.57-86.55-19.73-9.13-.8-4.55-30.64,3.71s-.9,9.21-.9,9.21-2.81,8.13-4.4,12.33c-4.94,13-11.7,28.62-10.71,40,.45,5.17,7.53,39.55,7.53,39.55l-2.73,27.78Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516,254.55a4.43,4.43,0,0,1-.24.76c-.2.53-.47,1.23-.8,2.12-.7,1.84-1.78,4.47-3.12,7.73s-2.92,7.12-4.34,11.54a84.19,84.19,0,0,0-3.33,14.69,47.76,47.76,0,0,0,.17,15c.78,4.56,2,8.58,2.8,12s1.33,6.23,1.64,8.18c.12.94.22,1.68.29,2.25a4.55,4.55,0,0,1,.07.78,3.58,3.58,0,0,1-.17-.77c-.1-.56-.23-1.3-.39-2.23-.37-1.93-.91-4.72-1.79-8.12s-2.1-7.42-2.93-12a47.78,47.78,0,0,1-.2-15.15A82,82,0,0,1,507,276.55c1.46-4.43,3.09-8.3,4.46-11.54l3.28-7.66c.36-.87.66-1.56.88-2.08A4.88,4.88,0,0,1,516,254.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512.2,344.5c-1,4.79,2.9,9.49,7.48,11.19s9.66,1.15,14.51.58l33.84-4c1.79-.21,3.87-.63,4.64-2.25a4.1,4.1,0,0,0,0-2.89,10.85,10.85,0,0,0-5.69-6.28,24,24,0,0,0-8.41-2.1c-11.65-1.17-23.35.9-34.87,3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M485.81,327.35l8.61.78,3.76,1.9s-.9-1-1.68-1.95a29.94,29.94,0,0,0-3.82-3.17l-6.41-.66s-3.6-.27-3.83-2.76l4.9-.47s-5.07-.35-5-2.88l3.71-.66a1.16,1.16,0,0,1-1.16-1.35L495.15,315l9.77,6.93,9.44,8.35,2.13.09.74,13.64s-8.37-1-10.66-2.16-12.44-10.3-12.44-10.3-5.32-.47-6.79-1.74A3.87,3.87,0,0,1,485.81,327.35Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.3,344.2h-.14l-.39,0-1.54-.17c-1.34-.16-3.32-.41-5.83-.83a34.28,34.28,0,0,1-4.14-.92,6.79,6.79,0,0,1-2.13-1.18c-.68-.49-1.36-1-2.05-1.59-2.79-2.25-5.85-4.9-9.16-7.86l.11.05a28.37,28.37,0,0,1-4.81-.83,9.26,9.26,0,0,1-1.22-.42,5.83,5.83,0,0,1-.6-.32l-.28-.2-.25-.23a4.83,4.83,0,0,1-.85-1.05,3.24,3.24,0,0,1-.5-1.32l0-.26.27,0,8.6.77h0l0,0,3.77,1.9-.28.37-1.2-1.4-.6-.7a7.89,7.89,0,0,0-.66-.63c-.93-.83-2-1.6-3-2.37l.12.05-3.85-.4-2-.2c-.32,0-.66-.06-1-.12a7.06,7.06,0,0,1-1-.24,4.55,4.55,0,0,1-1.7-.92,2.65,2.65,0,0,1-.9-1.75l0-.24.23,0,4.89-.47v.47a10.93,10.93,0,0,1-3.14-.71,4.41,4.41,0,0,1-1.39-.86,2.1,2.1,0,0,1-.64-1.56v-.19l.19,0,3.93-.57v.46a1.9,1.9,0,0,1-1.09-.48,1.42,1.42,0,0,1-.42-1.14l0-.19.18,0L495,314.71h.09l.06.05L505,321.7h0c3.62,3.23,6.77,6,9.41,8.38l-.09,0,8.71.49,2.31.14.59.05c.14,0,.2,0,.2,0h-.8L523,330.7l-8.71-.36h0l0,0L504.72,322h0L495,315.1l.14,0L485,316.35l.2-.21a.93.93,0,0,0,.28.78,1.53,1.53,0,0,0,.82.35l1.67.22-1.66.24-3.93.57.2-.22a1.55,1.55,0,0,0,.51,1.2,3.77,3.77,0,0,0,1.23.77,10.82,10.82,0,0,0,3,.67v.47l-4.89.48.22-.26a2.14,2.14,0,0,0,.74,1.43,3.93,3.93,0,0,0,1.52.82,5.26,5.26,0,0,0,.95.23,9.78,9.78,0,0,0,1,.11l2,.21,3.85.39h.06l.05,0c1.06.77,2.09,1.55,3.05,2.39.24.22.47.44.69.68l.61.71,1.19,1.38.77.9-1.05-.53-3.76-1.91.08,0-8.6-.79.23-.23a3.14,3.14,0,0,0,.43,1.13,4.32,4.32,0,0,0,3,2,28,28,0,0,0,4.73.84h.07l0,0c3.3,3,6.34,5.64,9.1,7.9.68.57,1.36,1.11,2,1.6a6.65,6.65,0,0,0,2,1.16,34.73,34.73,0,0,0,4.09.95c2.5.46,4.47.74,5.81.94l1.53.23.39.06Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.81,325.19a9.23,9.23,0,0,1-1.76-1.09c-1-.73-2.47-1.75-4-2.91l-.43-.32.15.05c-1.81.07-3.44.11-4.61.12a7.83,7.83,0,0,1-1.88-.08,7.48,7.48,0,0,1,1.87-.25c1.17-.09,2.79-.19,4.6-.27h.09l.06.05.43.32c1.56,1.15,2.95,2.22,3.95,3A8.87,8.87,0,0,1,499.81,325.19Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.72,320.63a7.69,7.69,0,0,1-1.61-1c-1-.67-2.28-1.62-3.74-2.7l.17.05-.57.06c-1.94.2-3.71.35-5,.44a8.44,8.44,0,0,1-2.08,0,10.12,10.12,0,0,1,2-.38c1.27-.17,3-.38,5-.58l.57-.06h.09l.08.06c1.45,1.09,2.74,2.08,3.65,2.81A8.43,8.43,0,0,1,498.72,320.63Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.88,335.76a24.25,24.25,0,0,0,3.72-16.46l-7.45-43.77c-.85-7.32-1.89-17.32-7-22.66-3.49-3.67-7.73-6.88-11.9-6.84l-8.94,25.36,3.36,49-45.36,8.12v19.88s34.66-1.15,53.95-1.68a24.19,24.19,0,0,0,19.58-10.95Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.88,335.76l-.21.33-.63,1a26.06,26.06,0,0,1-2.91,3.3,24.52,24.52,0,0,1-5.75,4,24.07,24.07,0,0,1-9,2.48c-13.86.53-33.16,1.12-55,1.82h-.27V328.29l.22,0,45.36-8.07-.17.23c-1.19-11.32-2.18-20.64-2.87-27.16-.32-3.23-.58-5.77-.76-7.52-.08-.85-.14-1.5-.18-2s0-.68,0-.68,0,.23.1.67.14,1.12.25,2c.2,1.75.5,4.28.87,7.5.73,6.52,1.78,15.83,3,27.14l0,.2-.19,0-45.35,8.17.21-.25v19.88l-.27-.26,55-1.65a24.14,24.14,0,0,0,8.89-2.38,24.6,24.6,0,0,0,5.74-3.89,27.14,27.14,0,0,0,3-3.23c.29-.39.51-.69.67-.92A2,2,0,0,1,587.88,335.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.33,247.68c0,.1-1.53.68-3.79,2.13a26,26,0,0,0-3.69,2.89,29.61,29.61,0,0,0-3.76,4.33,30,30,0,0,0-2.75,5,26,26,0,0,0-1.42,4.47c-.57,2.62-.58,4.3-.68,4.29a4.68,4.68,0,0,1,0-1.17,9.2,9.2,0,0,1,.1-1.38,13.58,13.58,0,0,1,.26-1.81,24.3,24.3,0,0,1,1.33-4.58,28.39,28.39,0,0,1,2.78-5.15,27.92,27.92,0,0,1,3.85-4.39,24.51,24.51,0,0,1,3.83-2.84,15.79,15.79,0,0,1,1.61-.88,9.7,9.7,0,0,1,1.26-.56A4.46,4.46,0,0,1,570.33,247.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.72,238.41a3.38,3.38,0,0,1-1.1.76,34.19,34.19,0,0,1-3.37,1.36c-2.85,1.08-6.61,3-10.9,4.86a33.29,33.29,0,0,1-11.57,3,16.92,16.92,0,0,1-3.64-.2c-.43-.06-.75-.14-1-.19s-.33-.1-.33-.12a31,31,0,0,0,4.92.14,35.8,35.8,0,0,0,11.39-3.13c4.26-1.85,8.07-3.72,11-4.72,1.45-.52,2.64-.85,3.41-1.2S551.69,238.37,551.72,238.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "442.44 314.09 437.94 278.76 407.16 280.27 409.31 315.73 442.44 314.09",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.63,287.67a2.83,2.83,0,0,1-3.31.05c-1-.59-1.81-1.52-2.79-2.18-2.93-2-7.09-1.44-9.92-3.57-.4-.29-.79-.78-.58-1.23s.74-.48,1.2-.47l11.73.09",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443,280.36a4.24,4.24,0,0,0-1.27-.14c-.81-.05-2-.09-3.46-.14l-5.12-.11-1.49,0a2.31,2.31,0,0,0-1.71.39,1,1,0,0,0-.18,1.09,2.07,2.07,0,0,0,.6.75,7.48,7.48,0,0,0,1.49.88c2.13.95,4.3,1.09,6.1,1.64a8.68,8.68,0,0,1,2.43,1.06c.69.45,1.27,1,1.85,1.46a4.14,4.14,0,0,0,3.32,1.11c.86-.18,1.14-.66,1.11-.66a3.55,3.55,0,0,1-1.15.4,4,4,0,0,1-3-1.22c-.55-.46-1.11-1-1.84-1.55a9.12,9.12,0,0,0-2.56-1.19c-1.87-.6-4-.77-6-1.65a7.51,7.51,0,0,1-1.35-.8c-.38-.3-.58-.71-.37-.87s.74-.21,1.24-.2h1.48l5.13,0c1.46,0,2.64-.05,3.46-.08A5.44,5.44,0,0,0,443,280.36Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.93,290.66a4.07,4.07,0,0,1-.87.43,20.64,20.64,0,0,1-2.51.88,10.88,10.88,0,0,1-3.95.43,7.69,7.69,0,0,1-2.31-.58,9.73,9.73,0,0,1-2.1-1.4,1.92,1.92,0,0,0-1-.4,1.43,1.43,0,0,0-.94.37,8,8,0,0,0-1.3,1.81,2.47,2.47,0,0,1-1.84,1.24,2.68,2.68,0,0,1-1.82-.65,4.54,4.54,0,0,1-1.3-2.36,3.11,3.11,0,0,1-.16-1,4,4,0,0,1,.36.9,4.55,4.55,0,0,0,1.33,2.13,2.35,2.35,0,0,0,1.56.51,2,2,0,0,0,1.47-1.08A7.92,7.92,0,0,1,419.9,290a1.89,1.89,0,0,1,1.29-.5,2.39,2.39,0,0,1,1.3.5,9.57,9.57,0,0,0,2,1.35,7.07,7.07,0,0,0,2.15.57,11.16,11.16,0,0,0,3.81-.31C432.6,291.08,433.9,290.57,433.93,290.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.38,296c0,.14-4.64.46-10.39.71a100,100,0,0,1-10.41.2c0-.14,4.64-.46,10.39-.72A101.53,101.53,0,0,1,435.38,296Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.25,301a12,12,0,0,1-2.34.61c-1.46.31-3.49.68-5.74,1s-4.29.6-5.78.74a10.48,10.48,0,0,1-2.41.12,11.88,11.88,0,0,1,2.36-.48l5.75-.9,5.75-.87A10.49,10.49,0,0,1,433.25,301Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.15,291.08a2.26,2.26,0,0,1-.43.39l-1.28,1c-1.13.87-2.77,2.14-4.93,3.52a29.37,29.37,0,0,1-8.16,3.77,17.18,17.18,0,0,1-10.94-.37c-3.69-1.49-6.54-4-9.28-5.93a20.51,20.51,0,0,0-7.92-3.84,10.23,10.23,0,0,0-5.87.29,16.75,16.75,0,0,0-1.95,1,6,6,0,0,1,1.87-1.21,10.14,10.14,0,0,1,6-.46,20.54,20.54,0,0,1,8.13,3.81c2.77,1.92,5.61,4.4,9.19,5.84a16.89,16.89,0,0,0,10.62.39,30.34,30.34,0,0,0,8.1-3.62c2.16-1.34,3.83-2.55,5-3.38l1.34-.94A2.53,2.53,0,0,1,555.15,291.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.65,271.31c0,.1-1.54-.36-4-.73a34.2,34.2,0,0,0-4.43-.35,38.5,38.5,0,0,0-5.41.34,37.32,37.32,0,0,0-5.3,1.21,33.49,33.49,0,0,0-4.14,1.59c-2.3,1.06-3.62,1.93-3.67,1.84a4.78,4.78,0,0,1,.89-.66,23.28,23.28,0,0,1,2.62-1.52,31.15,31.15,0,0,1,4.16-1.71,31.59,31.59,0,0,1,10.86-1.57,29.68,29.68,0,0,1,4.47.47,22.2,22.2,0,0,1,3,.71A4.66,4.66,0,0,1,583.65,271.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.25,307.63a10.47,10.47,0,0,0-4.63.49,27.65,27.65,0,0,0-4.62,2.19,21.61,21.61,0,0,1-5.87,2.47,16.79,16.79,0,0,1-11.31-1.56,16.23,16.23,0,0,1-2.88-2,5.81,5.81,0,0,1-.88-.93,25.66,25.66,0,0,0,3.93,2.6,17,17,0,0,0,11,1.38,22.47,22.47,0,0,0,5.76-2.38,25.25,25.25,0,0,1,4.74-2.12,9.82,9.82,0,0,1,3.49-.42A3.14,3.14,0,0,1,589.25,307.63Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.32,347.43c-.09,0,.57-1.32,1.15-3.53a20.79,20.79,0,0,0-2.84-17c-1.27-1.91-2.31-2.9-2.24-3a3.53,3.53,0,0,1,.76.66,16.65,16.65,0,0,1,1.78,2.1,19.8,19.8,0,0,1,2.9,17.34,18,18,0,0,1-1,2.56A3.56,3.56,0,0,1,548.32,347.43Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.94,266.53c-.14.06-.59-.79-1.58-1.34s-1.94-.51-2-.66,1.06-.45,2.21.21S510.08,266.51,509.94,266.53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.22,245.08c0,.06-.75-.09-2.09,0a12.28,12.28,0,0,0-5.27,2,20.81,20.81,0,0,0-3.09,2.41c-1,1-2.07,2.08-3.14,3.27-2.15,2.33-4.54,5.1-8,6.77a20.76,20.76,0,0,1-10.28,1.84,35.9,35.9,0,0,1-8.39-1.65c-2.32-.73-4.15-1.45-5.41-1.95l-1.44-.6a1.81,1.81,0,0,1-.49-.24,2,2,0,0,1,.53.14l1.47.51c1.28.44,3.13,1.1,5.45,1.78a36.08,36.08,0,0,0,8.3,1.53,20.59,20.59,0,0,0,10-1.83c3.29-1.6,5.66-4.3,7.83-6.63,1.09-1.17,2.14-2.29,3.2-3.26a21.63,21.63,0,0,1,3.19-2.4,12,12,0,0,1,5.45-1.85,7.12,7.12,0,0,1,1.57.06A2.36,2.36,0,0,1,563.22,245.08Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.92,235.91a6,6,0,0,1-1.09.53c-.7.32-1.75.74-3.05,1.22a75.71,75.71,0,0,1-10.43,3,76.77,76.77,0,0,1-10.75,1.47c-1.39.09-2.51.12-3.29.12a4.75,4.75,0,0,1-1.2-.06,6.57,6.57,0,0,1,1.2-.15c.77-.05,1.89-.14,3.26-.28a98.88,98.88,0,0,0,10.67-1.61,97.54,97.54,0,0,0,10.42-2.82c1.31-.44,2.37-.8,3.1-1.06A4.64,4.64,0,0,1,549.92,235.91Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.93,321.75s-.06-.09-.12-.28a4.75,4.75,0,0,1-.18-.82,8.93,8.93,0,0,1,.11-3.12,16.86,16.86,0,0,1,1.59-4.33c.79-1.55,1.83-3.14,2.82-4.85a18.89,18.89,0,0,0,2.17-5.06,10.52,10.52,0,0,0,.09-4.45,14.56,14.56,0,0,0-1.48-3.88,3.24,3.24,0,0,1,.68.92,9.73,9.73,0,0,1,1.16,2.89,10.56,10.56,0,0,1,0,4.63,18.54,18.54,0,0,1-2.19,5.21c-1,1.73-2.05,3.3-2.85,4.81a17.8,17.8,0,0,0-1.65,4.19A11.52,11.52,0,0,0,468.93,321.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.76,360a5.26,5.26,0,0,1-.68-.36c-.43-.26-1.1-.58-2-1a22.25,22.25,0,0,0-7.83-1.72,38.19,38.19,0,0,0-11.82,1.49c-4.35,1.18-9,3.08-13.91,4.79a46.33,46.33,0,0,1-14.45,3,34.39,34.39,0,0,1-11.88-1.94,33.42,33.42,0,0,1-7.28-3.61c-.8-.54-1.4-1-1.79-1.3a4.75,4.75,0,0,1-.59-.49c0-.05.86.61,2.49,1.62a35.77,35.77,0,0,0,7.29,3.43,35,35,0,0,0,11.76,1.81,46.57,46.57,0,0,0,14.28-3c4.93-1.7,9.56-3.59,14-4.76a37.53,37.53,0,0,1,12-1.4,21.8,21.8,0,0,1,7.89,1.9,14.81,14.81,0,0,1,1.93,1.09A3.19,3.19,0,0,1,581.76,360Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.83,396.77a14.13,14.13,0,0,1-2.74,2,22.51,22.51,0,0,1-8.76,2.77,32,32,0,0,1-6.38.08,43.91,43.91,0,0,1-7.2-1.31c-5-1.29-10.24-3.46-15.82-5.41s-11.1-3.3-16.21-3.28a26.69,26.69,0,0,0-7.15,1c-2.19.59-4.21,1.3-6.12,1.72a12.42,12.42,0,0,1-9.05-.78,6.81,6.81,0,0,1-1.94-1.6,4.09,4.09,0,0,1-.49-.73,8.57,8.57,0,0,1,.57.66,7.07,7.07,0,0,0,2,1.49,12.35,12.35,0,0,0,8.87.6c1.88-.44,3.88-1.16,6.09-1.78a26.89,26.89,0,0,1,7.25-1c5.2-.05,10.8,1.32,16.39,3.27s10.82,4.13,15.77,5.43a43.47,43.47,0,0,0,7.12,1.35,33.05,33.05,0,0,0,6.3,0,23,23,0,0,0,8.7-2.59,12.88,12.88,0,0,0,1.24-.72c.36-.22.65-.42.88-.59A5.32,5.32,0,0,1,588.83,396.77Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.38,426.24a1.37,1.37,0,0,1-.21-.11l-.61-.36a23.78,23.78,0,0,0-2.37-1.26,29.38,29.38,0,0,0-9.51-2.51,49,49,0,0,0-14.57,1c-5.42,1.08-11.24,2.91-17.47,4.41a74.31,74.31,0,0,1-9.21,1.68,62.45,62.45,0,0,1-23.3-1.88,59.62,59.62,0,0,1-9.33-3.42c-1.07-.48-1.87-.92-2.42-1.21-.24-.13-.45-.24-.61-.34s-.21-.12-.2-.13a1.21,1.21,0,0,1,.22.09l.64.29c.56.26,1.37.66,2.45,1.11a63.27,63.27,0,0,0,9.35,3.25,62.42,62.42,0,0,0,14.49,2.09,64.09,64.09,0,0,0,8.65-.36,75.58,75.58,0,0,0,9.15-1.67c6.2-1.5,12-3.32,17.5-4.38a48.12,48.12,0,0,1,14.7-.86,28.11,28.11,0,0,1,9.56,2.69A17.08,17.08,0,0,1,593.38,426.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.07,323.32c-.05.09-1.74-.85-4.67-1.87a38.25,38.25,0,0,0-5.25-1.38,36.76,36.76,0,0,0-13.23,0,36.4,36.4,0,0,0-5.26,1.34c-2.93,1-4.63,1.92-4.68,1.83a6.91,6.91,0,0,1,1.17-.69,15.33,15.33,0,0,1,1.44-.69c.57-.25,1.21-.55,1.95-.8a33.55,33.55,0,0,1,5.3-1.47,35.12,35.12,0,0,1,13.4.05,33,33,0,0,1,5.28,1.51c.75.25,1.38.56,2,.81a13.75,13.75,0,0,1,1.43.7A6.47,6.47,0,0,1,541.07,323.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.67,457.34s-.08,0-.22-.09l-.6-.33c-.26-.15-.59-.33-1-.52s-.85-.42-1.37-.64a32.32,32.32,0,0,0-9.29-2.46,56.39,56.39,0,0,0-14.27.29c-5.36.66-11.18,1.89-17.4,2.62a102.8,102.8,0,0,1-31.88-1.29,96.13,96.13,0,0,1-9.4-2.36c-1.1-.32-1.93-.63-2.51-.82l-.64-.23a.73.73,0,0,1-.22-.09.61.61,0,0,1,.24,0l.66.18c.58.16,1.42.44,2.53.73,2.19.62,5.4,1.43,9.41,2.19a106.18,106.18,0,0,0,31.75,1.13c6.19-.72,12-1.94,17.4-2.58a55.41,55.41,0,0,1,14.38-.18,31.76,31.76,0,0,1,9.32,2.64,15.27,15.27,0,0,1,1.36.7,10.65,10.65,0,0,1,1,.56l.57.37Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.66,464.5l2-91.36-71-5.92s-3.78,36.57-3.69,41.46c0,2.33,10.71,25.08,10.71,25.08l-.12,30.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.55,384a7.38,7.38,0,0,1-.59,1.32c-.41.83-1.05,2-1.9,3.46a39,39,0,0,1-8.24,10.06,23.3,23.3,0,0,1-11.77,5.4,16.76,16.76,0,0,1-4,.07,10.29,10.29,0,0,1-1.06-.17,1.37,1.37,0,0,1-.37-.09,27.28,27.28,0,0,0,5.34-.17,24.2,24.2,0,0,0,11.49-5.44,42,42,0,0,0,8.26-9.86c.89-1.4,1.56-2.56,2-3.36A8.14,8.14,0,0,1,172.55,384Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.12,233.09l32,8.34,1.09-27.91s13.53-1.52,14.27-15-.28-44.39-.28-44.39h0a46.76,46.76,0,0,0-47.18,3.89L144,159.52Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.28,213.32A31.28,31.28,0,0,1,162,207.6s3.73,9.85,17.19,9.21Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.06,173.51c-.22-.11-9.11-3.12-9.21,6.08S145,187,145,186.73,145.06,173.51,145.06,173.51Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.25,183.21s-.16.11-.43.23a1.57,1.57,0,0,1-1.2,0c-1-.36-1.77-1.91-1.8-3.57a5.24,5.24,0,0,1,.48-2.29,1.82,1.82,0,0,1,1.22-1.22.82.82,0,0,1,.94.45c.12.26.06.44.11.46s.19-.16.12-.54a1,1,0,0,0-.35-.58,1.24,1.24,0,0,0-.89-.24,2.23,2.23,0,0,0-1.68,1.41,5.43,5.43,0,0,0-.59,2.56c0,1.85,1,3.6,2.3,4a1.73,1.73,0,0,0,1.47-.22C142.23,183.43,142.28,183.23,142.25,183.21Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.39,174.88a1.92,1.92,0,0,1-1.93,1.86,1.85,1.85,0,0,1-1.91-1.82,1.93,1.93,0,0,1,1.94-1.86A1.83,1.83,0,0,1,189.39,174.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.89,173c-.25.24-1.65-.89-3.72-1s-3.62.89-3.84.63.16-.56.84-1a5.22,5.22,0,0,1,3.09-.81,5.1,5.1,0,0,1,3,1.09C189.82,172.4,190,172.87,189.89,173Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.14,174.74a1.93,1.93,0,0,1-1.94,1.85,1.83,1.83,0,0,1-1.9-1.81,1.92,1.92,0,0,1,1.93-1.86A1.85,1.85,0,0,1,169.14,174.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.58,172.49c-.25.24-1.66-.9-3.73-1s-3.62.89-3.83.63.15-.56.83-1a5.22,5.22,0,0,1,3.09-.81,5.07,5.07,0,0,1,2.95,1.09C169.5,171.92,169.7,172.39,169.58,172.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.42,188.13a13.17,13.17,0,0,1,3.38-.46c.53,0,1-.12,1.14-.47a2.69,2.69,0,0,0-.29-1.58c-.44-1.3-.9-2.66-1.39-4.09-1.92-5.81-3.29-10.57-3-10.65s2,4.57,3.9,10.38l1.32,4.11a3,3,0,0,1,.19,2.08,1.3,1.3,0,0,1-.9.73,3.8,3.8,0,0,1-.9.09A13.5,13.5,0,0,1,176.42,188.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.45,164.42c-.22.55-2.27.2-4.71.39s-4.42.77-4.72.25c-.14-.25.23-.76,1-1.27a7.76,7.76,0,0,1,3.54-1.07,7.92,7.92,0,0,1,3.65.58C170.12,163.7,170.55,164.16,170.45,164.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.39,167c-.38.46-1.79-.09-3.5-.19s-3.17.18-3.48-.32c-.14-.24.11-.7.76-1.12a4.87,4.87,0,0,1,2.88-.65,4.93,4.93,0,0,1,2.75,1.06C189.38,166.25,189.56,166.74,189.39,167Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.15,146a5,5,0,0,0-1.64-4.51,3.51,3.51,0,0,0-4.57.15,4.11,4.11,0,0,0-3.32-5.13c-2.19-.24-4.13,1.34-6.27,1.83a10,10,0,0,1-6.24-1c-2-.89-3.77-2.07-5.75-2.89A17.18,17.18,0,0,0,150,143.58c-2.9-1-6.31.31-8.23,2.72a12.55,12.55,0,0,0-2.29,8.73,28.43,28.43,0,0,0,1.28,6.1c0,.17,0,.34,0,.51-.17,7.4.29,16.12,3.44,16.3,5.5.32,4.63-10.09,4.63-10.09,6.85-2.32,4.77-12.53,6.52-14s5.43-4.87,19.25,2.94c5.36,3,12.65,3.26,16.67,2.53l.36-.06h.08l.12,0a13,13,0,0,0,3.68-1.38,7.15,7.15,0,0,0,3.13-3.19,3.93,3.93,0,0,0-.59-4.24A8.6,8.6,0,0,0,200.15,146Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.5,194.54a9.15,9.15,0,0,1-1.3,2.3,3.14,3.14,0,0,1-2.27,1.19,2.81,2.81,0,0,1-2.31-1.39,4.44,4.44,0,0,1-.54-2.72c.07-.85.5-1.85,1.35-1.91a2,2,0,0,1,1,.27l4.36,2",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.58,198.11a6.33,6.33,0,0,1-2.36-.39,3.4,3.4,0,0,1-1.71-1.7,3.54,3.54,0,0,1,.06-2.9,2.9,2.9,0,0,1,.42-.65c.18-.18.15-.17.34-.13a5.55,5.55,0,0,1,.69.31l.72.32c.93.43,1.78.8,2.49,1.1a7.91,7.91,0,0,0,2.38.83,7.86,7.86,0,0,0-2.14-1.33c-.68-.37-1.5-.8-2.41-1.26l-.71-.35c-.25-.11-.45-.24-.79-.37a1.06,1.06,0,0,0-.66,0,1.19,1.19,0,0,0-.51.36,4,4,0,0,0-.53.82,4.12,4.12,0,0,0,0,3.55,3.82,3.82,0,0,0,2.17,1.92,3.51,3.51,0,0,0,1.92.15C175.38,198.3,175.59,198.16,175.58,198.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.47,152.57a9.09,9.09,0,0,1,.07-1.63,6.28,6.28,0,0,1,2.26-3.68,8.5,8.5,0,0,1,6.13-1.74,26,26,0,0,1,7.79,2.09,41.27,41.27,0,0,0,4,1.35,21.11,21.11,0,0,0,10.57.06,20.13,20.13,0,0,0,4.21-1.58,11.17,11.17,0,0,0,1.07-.6,2,2,0,0,0,.36-.24s-.53.27-1.49.7a23.08,23.08,0,0,1-4.22,1.45,21.33,21.33,0,0,1-10.4-.16c-1.31-.35-2.63-.84-4-1.35a25.9,25.9,0,0,0-7.91-2.09,8.78,8.78,0,0,0-6.33,1.89,6.37,6.37,0,0,0-2.24,3.88A3.77,3.77,0,0,0,154.47,152.57Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.05,174.83s.08-.08.19-.27.27-.47.46-.84a17.33,17.33,0,0,0,1.21-3.29,18.28,18.28,0,0,0,.57-5.18,47.29,47.29,0,0,0-.93-6.3,12.15,12.15,0,0,1,.25-6.18,6.19,6.19,0,0,1,1.38-2.28,4.81,4.81,0,0,1,2-1.19,4.41,4.41,0,0,1,3.31.23,5.56,5.56,0,0,1,1,.77,2.57,2.57,0,0,0-.92-.9,4.47,4.47,0,0,0-3.47-.37,5,5,0,0,0-2.14,1.23,6.54,6.54,0,0,0-1.5,2.39,12.42,12.42,0,0,0-.3,6.36,47.72,47.72,0,0,1,1,6.25,18.84,18.84,0,0,1-.47,5.1,20.85,20.85,0,0,1-1.08,3.3C143.24,174.41,143,174.82,143.05,174.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.23,151.43a3.25,3.25,0,0,0,0-.54v-1.55a18.24,18.24,0,0,1,.86-5.55,10.11,10.11,0,0,1,1.94-3.31,7,7,0,0,1,3.71-2.23,9.06,9.06,0,0,1,4.8.4,22.07,22.07,0,0,1,4.72,2.39,39.62,39.62,0,0,0,4.66,2.65,14.55,14.55,0,0,0,4.87,1.2,15.85,15.85,0,0,0,4.53-.36,17.15,17.15,0,0,0,3.71-1.35,14.74,14.74,0,0,0,4.48-3.51,9.14,9.14,0,0,0,.94-1.24,3,3,0,0,0,.28-.46,2.4,2.4,0,0,0-.35.42,11.88,11.88,0,0,1-1,1.18,15.59,15.59,0,0,1-4.49,3.36,17.64,17.64,0,0,1-3.66,1.28,15.63,15.63,0,0,1-4.43.32,14.44,14.44,0,0,1-4.74-1.19,40.29,40.29,0,0,1-4.62-2.64,22.53,22.53,0,0,0-4.8-2.42,9.46,9.46,0,0,0-5-.39,7.23,7.23,0,0,0-3.87,2.37,10.11,10.11,0,0,0-2,3.44,17.09,17.09,0,0,0-.75,5.64c0,.68,0,1.2.07,1.55A2.64,2.64,0,0,0,153.23,151.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.77,269.49l40.45-45.42,5.74-8s14-17.32,15.13-19.15c1.31-2.12,2.64-2,3.39-1.46,1.17.83,1.1,2.86,0,4.72-.36.64-6.59,10.51-6.59,10.51a27.49,27.49,0,0,1,3.58-1.49c2.62-1,6.72.13,10.19,2.43s4.23,3.26,3.4,4.64a2.06,2.06,0,0,1-1.52.91,5.85,5.85,0,0,1-3.33-.79c-6.85-4.09-8.5-1.38-8.5-1.38l-.92,1s5.13-.3,7.23,2.44a4.09,4.09,0,0,1,.68,1.35,5.21,5.21,0,0,1-.26,9,2.15,2.15,0,0,1-2.46,0,2.78,2.78,0,0,1-.63-1.23,4,4,0,0,0-.27-.68l-2.52,2.64s-6,5.64-8.29,8.39l-35.71,44.63c-4.65,6.73-11.67,12.31-18.32,7.55h0C207,284.92,207.63,275.92,213.77,269.49Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.27,224.4a3,3,0,0,0,3.54.25c1.13-.57,2-1.51,3.12-2.16,3.25-2,7.67-1.11,10.82-3.22.44-.29.89-.79.7-1.28s-.77-.55-1.26-.58l-12.55-.61",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.64,216.8a5.07,5.07,0,0,1,1.36-.07c.88,0,2.15,0,3.71.06l5.49.19,1.59.07a2.46,2.46,0,0,1,1.81.52,1,1,0,0,1,.12,1.18,2.13,2.13,0,0,1-.69.76,8,8,0,0,1-1.64.86c-2.34.88-4.66.9-6.63,1.38a9.46,9.46,0,0,0-2.65,1c-.77.44-1.42,1-2.08,1.45a4.43,4.43,0,0,1-3.61,1c-.91-.25-1.18-.77-1.15-.77a4,4,0,0,0,1.21.5,4.32,4.32,0,0,0,3.26-1.13,25,25,0,0,1,2.06-1.55,9.59,9.59,0,0,1,2.81-1.11c2-.53,4.36-.59,6.52-1.41a8,8,0,0,0,1.48-.77c.43-.29.67-.72.46-.91s-.78-.26-1.32-.29l-1.58-.09-5.49-.34c-1.56-.11-2.82-.21-3.69-.3A4.94,4.94,0,0,1,260.64,216.8Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.82,216a5.12,5.12,0,0,1,1.83-1.51,4,4,0,0,1,2.5-.18,10.21,10.21,0,0,1,2.92,1.27,16.1,16.1,0,0,0,3,1.49,5.24,5.24,0,0,0,2.72.25,2.06,2.06,0,0,0,1.47-1.12,1.14,1.14,0,0,0,.15-.66s-.1.22-.31.58a1.92,1.92,0,0,1-1.37.88,5.17,5.17,0,0,1-2.52-.33,17.49,17.49,0,0,1-2.86-1.49,10.12,10.12,0,0,0-3.07-1.29,4.24,4.24,0,0,0-2.72.3,3.82,3.82,0,0,0-1.41,1.2A1.42,1.42,0,0,0,274.82,216Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.91,199.43a14.82,14.82,0,0,0-1.25,2c-.82,1.36-1.8,3-2.89,4.78s-2.11,3.39-3,4.74a14.8,14.8,0,0,0-1.18,2,10.29,10.29,0,0,0,1.46-1.81c.83-1.17,1.93-2.81,3.08-4.68s2.12-3.59,2.78-4.86A9.9,9.9,0,0,0,278.91,199.43Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.68,219.63s.25.06.71.13a2.19,2.19,0,0,1,1.57.87,1.17,1.17,0,0,1,0,1.15,5.69,5.69,0,0,1-.89,1.22,2.66,2.66,0,0,0-.72,1.7,2.2,2.2,0,0,0,1,1.72,2.52,2.52,0,0,0,2,.29,3.13,3.13,0,0,0,1.59-.93,10.15,10.15,0,0,0,1.53-2.56,5.93,5.93,0,0,0,.51-1.94,1.39,1.39,0,0,0-.1-.74c-.05,0,0,.27-.08.72a6.84,6.84,0,0,1-.63,1.83,11,11,0,0,1-1.54,2.41,2.49,2.49,0,0,1-3,.53,1.77,1.77,0,0,1-.83-1.35,2.25,2.25,0,0,1,.61-1.41,5.94,5.94,0,0,0,.9-1.34,1.5,1.5,0,0,0-.07-1.47,2.27,2.27,0,0,0-1.83-.88A1.89,1.89,0,0,0,275.68,219.63Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.37,226.31s-.21.16-.3.59a2,2,0,0,0,.53,1.73,2.68,2.68,0,0,0,2.58.68,4.4,4.4,0,0,0,2.59-2,5.37,5.37,0,0,0,.79-3.18,5.06,5.06,0,0,0-.89-2.51,4.84,4.84,0,0,0-1.26-1.27,1.6,1.6,0,0,0-.59-.29,8.54,8.54,0,0,1,1.58,1.74,4.95,4.95,0,0,1,0,5.26,4.14,4.14,0,0,1-2.3,1.85,2.38,2.38,0,0,1-2.25-.5,1.9,1.9,0,0,1-.58-1.47C279.28,226.53,279.4,226.33,279.37,226.31Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.43,228.71a1.93,1.93,0,0,0-1-.57,4.29,4.29,0,0,0-2.84,0l.28.3a14.28,14.28,0,0,0,.6-1.46,10,10,0,0,0,.52-5.4,26.33,26.33,0,0,1-1,5.25c-.17.51-.37,1-.56,1.42l-.22.48.49-.18a4.57,4.57,0,0,1,2.61-.12C268,228.56,268.4,228.76,268.43,228.71Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.07,211.94c-.12,0-.18.94.46,1.85s1.54,1.2,1.58,1.08-.65-.54-1.2-1.34S279.21,211.93,279.07,211.94Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.5,228.45,211,265.58l27.48-28.27,5.23-2.29,6.92-7,16,18.05-33.93,44.35A31.79,31.79,0,0,1,215.15,302h0a31.78,31.78,0,0,1-29.86-8.15l-28.88-28.31",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.65,287.14a25.1,25.1,0,0,1-.08-3.23,55.32,55.32,0,0,0-.61-7.74,46.3,46.3,0,0,0-1.9-7.52c-.64-1.89-1.1-3-1-3.07a2.7,2.7,0,0,1,.43.76c.25.5.58,1.25.95,2.18a37,37,0,0,1,2.06,7.56,42.66,42.66,0,0,1,.47,7.83c0,1-.09,1.81-.15,2.37A2.8,2.8,0,0,1,214.65,287.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M184.93,240.63c5.94,5.66,7.42,13,10.73,20.51,3.89,8.84,10.92,17.44,13.62,26.72a13.93,13.93,0,0,1,.1,8.52c-1,2.71-3.83,6-6.71,6.17l-6-1.59Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M259.07,255.91c-.11.09-3.58-4.13-7.75-9.43s-7.45-9.66-7.34-9.75,3.58,4.13,7.75,9.43S259.18,255.82,259.07,255.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.73 330.42 232.78 363.79 261.7 350.67 271.08 320.14 243.73 330.42",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.4,209.09l-4.24,10.25S135.68,231,129.54,239c-6.66,8.66-8.25,36.68-8.25,36.68l6.33,85.93-2.17,4.2c-1,1.92-.47,8.91,1.68,9l71.23,3.31c1.72.08,2.86-6,2.77-7.67l-5.74-103.8L183.84,238.3l-3.71-5.55-.08-7-24.79-7.67a15.68,15.68,0,0,1-9.86-9Z",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129,341.38c10.82,6.89,21.74,13.84,33.76,18.33s25.61,6.21,38,2.75l-.39-8.94-68.07-18.88Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M148.49,241.31S129,239.63,125,264s2.46,77.13,4.34,77.57c0,0,34.86,14.88,71.12,18.42l25.45-4.67-3-24.19-18.73,1s-.82-4.67-7.88-6.64c-10.17-2.84-30.65-7.56-30.65-7.56s.91-24.27,1.11-31.38,2.66-38-13.6-43.81",
    style: {
      fill: "#00CCAA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.84,238.3a5.18,5.18,0,0,1,.36.73l.93,2.12,3.31,7.83c1.39,3.33,3,7.27,4.86,11.64.46,1.1.93,2.22,1.4,3.37a18.38,18.38,0,0,1,1.2,3.65,22.61,22.61,0,0,1,.41,3.95c.08,1.33.15,2.68.23,4.05.63,10.94,1.21,20.85,1.49,28,.14,3.59.23,6.5.25,8.51,0,1,0,1.73,0,2.31a5.63,5.63,0,0,1,0,.81,3.7,3.7,0,0,1-.07-.81c0-.57-.07-1.34-.11-2.31-.1-2.06-.24-4.94-.42-8.49-.42-7.21-1-17.09-1.64-28-.08-1.37-.15-2.72-.23-4.05a22.28,22.28,0,0,0-.39-3.88,17.87,17.87,0,0,0-1.16-3.56l-1.38-3.38c-1.79-4.38-3.4-8.34-4.76-11.68s-2.39-6-3.16-7.89l-.84-2.16A7.25,7.25,0,0,1,183.84,238.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.89,225.71a5.87,5.87,0,0,1-.22,1c-.17.66-.44,1.63-.85,2.85a50.32,50.32,0,0,1-4.4,9.58l-.14.23-.21-.17a40.59,40.59,0,0,0-10.71-6c-3.43-1.42-6.77-2.62-9.7-4a37.44,37.44,0,0,1-7.37-4.42,20.93,20.93,0,0,1-4-4.16,12.57,12.57,0,0,1-.85-1.33,2,2,0,0,1-.24-.49c.05,0,.41.64,1.26,1.7a21.92,21.92,0,0,0,4.09,4,38.46,38.46,0,0,0,7.34,4.27c2.92,1.35,6.25,2.54,9.7,4a40.22,40.22,0,0,1,10.81,6.11l-.35.06a55.74,55.74,0,0,0,4.55-9.43c.44-1.2.75-2.15,1-2.8A5.54,5.54,0,0,1,179.89,225.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1,242.69s.46.16,1.35.52c.43.2,1,.5,1.57.84a15.27,15.27,0,0,1,2,1.48,19.58,19.58,0,0,1,4.21,5.38,36.07,36.07,0,0,1,3.16,8.74c1.61,6.81,2,15.39,1.58,25.18s-.71,20.88-1.12,33.06l-.17-.21c6.21,1.44,12.77,3,19.62,4.68,3.42.85,6.92,1.73,10.46,2.69a13.22,13.22,0,0,1,8.62,6.93l-.23-.14,18.73-1h.23l0,.23c1,7.71,2,15.86,3,24.19l0,.24-.24,0-23.67,4.35-1.77.32h-.08c-6.52-.7-12.94-1.63-19.21-2.86s-12.39-2.66-18.34-4.29a289.31,289.31,0,0,1-33.63-11.3h0a.45.45,0,0,1-.19-.11.44.44,0,0,1-.09-.11.71.71,0,0,1-.12-.2,2.2,2.2,0,0,1-.17-.39c-.09-.25-.17-.51-.24-.77q-.21-.76-.36-1.53c-.22-1-.41-2-.58-3.06-.35-2-.64-4-.91-6-.53-4-1-7.93-1.34-11.76-.75-7.68-1.25-15-1.53-21.93s-.32-13.43-.08-19.45a79.18,79.18,0,0,1,2.06-16.49A28,28,0,0,1,132,248.06a20.92,20.92,0,0,1,8.3-5.49,22,22,0,0,1,6.09-1.27,15.74,15.74,0,0,1,1.61,0,4.43,4.43,0,0,1,.54,0h-.55c-.35,0-.89,0-1.59.07a22.33,22.33,0,0,0-6,1.34,20.81,20.81,0,0,0-8.19,5.5A27.8,27.8,0,0,0,126,260a79.22,79.22,0,0,0-2,16.42c-.23,6-.16,12.51.13,19.42s.81,14.23,1.57,21.9c.38,3.84.82,7.76,1.36,11.75.27,2,.56,4,.91,6,.17,1,.36,2,.58,3,.11.51.23,1,.36,1.51.07.25.14.49.23.73s.09.24.14.33a.58.58,0,0,0,.08.14l0,0h0a.21.21,0,0,0,0,.12l.06-.11A291.8,291.8,0,0,0,163,352.56c5.94,1.62,12.06,3,18.3,4.27S194,359,200.45,359.69h-.07l1.77-.32L225.83,355l-.21.29c-1-8.32-2.06-16.48-3-24.18l.26.22-18.73,1H204l-.08-.15a12.77,12.77,0,0,0-8.3-6.67c-3.54-1-7-1.85-10.45-2.7-6.84-1.71-13.4-3.27-19.6-4.72l-.17,0v-.17c.45-12.18.85-23.27,1.21-33.07s.09-18.32-1.48-25.11A35.38,35.38,0,0,0,162,251a19.59,19.59,0,0,0-4.12-5.38,17.48,17.48,0,0,0-1.93-1.49c-.61-.35-1.12-.65-1.55-.86C153.55,242.9,153.1,242.69,153.1,242.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.8,357.36c-.14,0,.1-5.1.55-11.37s.91-11.34,1.06-11.33-.1,5.1-.55,11.37S203,357.37,202.8,357.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.82,331s0-.3.23-.8a12.89,12.89,0,0,1,1-2,20,20,0,0,1,5.16-5.4,38.73,38.73,0,0,1,6.47-3.71,16.28,16.28,0,0,1,2.85-1.18,19.93,19.93,0,0,1-2.69,1.5,52.79,52.79,0,0,0-6.32,3.81,22.16,22.16,0,0,0-5.16,5.18C150.32,329.92,149.9,331,149.82,331Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.37,365.77a1.38,1.38,0,0,1-.48.11l-1.41.23c-1.22.2-3,.41-5.21.58s-4.85.28-7.78.26-6.15-.21-9.51-.59-6.53-1-9.4-1.58-5.4-1.34-7.51-2-3.8-1.28-4.95-1.75l-1.31-.54a2.23,2.23,0,0,1-.45-.22,1.44,1.44,0,0,1,.48.12l1.35.45c1.17.41,2.87,1,5,1.58s4.66,1.29,7.5,1.91,6,1.14,9.36,1.53,6.55.56,9.46.63,5.54,0,7.75-.15,4-.27,5.21-.41l1.41-.13A1.89,1.89,0,0,1,178.37,365.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.9,326.84c-.75-1.07-2-.9-3.06-.13l-3.54,2.35a14.81,14.81,0,0,1-3.13,1.31l-1.51.27a11.51,11.51,0,0,1-8.48-1.8l-.61-.41s9.69-2.2,11.16-3.46l0,0a2,2,0,0,0-1.74-3.45l-12.2,1.87A25.06,25.06,0,0,0,231.76,328c-3.07,2.27-8.28,5.67-8.6,5.63l2.12,18.49,3.47-.86,6.32.56a22.59,22.59,0,0,0,12.35-2.45c2.35-1.21,4.55-2.43,4.78-2.83a34.43,34.43,0,0,0,1.46-4.61s2.4-1.49,2.49-2.51a16.36,16.36,0,0,0-.19-2.87s6.13-3.64,7.73-4.9C266.54,329.35,266.58,327.81,265.9,326.84Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.77,340.13a13,13,0,0,0,3.95-1.42,12.79,12.79,0,0,0,3.51-2.28c-.06-.1-1.63.91-3.69,1.93S248.73,340,248.77,340.13Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07,343.68a4.14,4.14,0,0,0,2.17-.61,4.09,4.09,0,0,0,1.78-1.39,16.47,16.47,0,0,0-2,1A15.08,15.08,0,0,0,250.07,343.68Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.73,327.33a6.61,6.61,0,0,0,1.47,1.05,20.56,20.56,0,0,0,3.94,1.88,14.17,14.17,0,0,0,4.31.72,5.76,5.76,0,0,0,1.81-.18,23.06,23.06,0,0,1-6-.92,27.72,27.72,0,0,1-3.93-1.75A9.27,9.27,0,0,0,243.73,327.33Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144,222.51c2.74,4.57,6.89,8.05,11.29,11.06a108.77,108.77,0,0,0,14,7.67c2.21,1.06,4.55,2.14,7,1.95a3.23,3.23,0,0,0,1.86-.66,4,4,0,0,0,1-2.52,82.34,82.34,0,0,0,.72-14.3,51.28,51.28,0,0,1-5.73,13.45s-3.86-3.35-15.78-8.17C146.27,226.1,144,222.51,144,222.51Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M158.63,433.76c-.15,0-.34-7.26-.43-16.21s0-16.21.1-16.21.34,7.26.42,16.21S158.77,433.75,158.63,433.76Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M715,464.81c0,.14-152.23.26-340,.26S35,465,35,464.81s152.19-.27,340-.27S715,464.66,715,464.81Z",
    style: {
      fill: "#263238"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScrumboardPana, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Scrum board-pana.3a41fa83.svg";
export { ForwardRef as ReactComponent };